(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const toggle = document.querySelector('[data-filter-toggle]');
    const panel = document.querySelector('[data-filter-panel]');
    toggle?.addEventListener('click', () => {
      panel?.classList.toggle('is-open');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // -------------------------------------------------------------
    // Header & Drawer Logic
    // -------------------------------------------------------------
    const header = document.querySelector('[data-pf-header]');
    const drawer = document.querySelector('[data-pf-header-drawer]');
    const openButtons = document.querySelectorAll('[data-pf-header-menu]');
    const closeButtons = document.querySelectorAll('[data-pf-header-close]');

    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    let lastKnownScrollY = 0;

    const getScrollPosition = () => {
      if (document.body.style.position === 'fixed') {
        const topVal = Math.abs(parseInt(document.body.style.top || '0', 10));
        if (!isNaN(topVal) && topVal > 0) {
          return topVal;
        }
        return lastKnownScrollY;
      }
      const y = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      lastKnownScrollY = y;
      return y;
    };

    const updateHeaderHeight = () => {
      if (!header) return;
      const h = header.offsetHeight;
      if (h > 0) {
        document.documentElement.style.setProperty('--header-height', `${h}px`);
        document.documentElement.style.setProperty('--header-height-mobile', `${h}px`);
        document.documentElement.style.setProperty('--header-group-height', `${h}px`);
      }
    };

    let prevScrolledState = null;
    const setScrollState = () => {
      if (!header) return;
      const currentScrollY = getScrollPosition();
      const isScrolled = currentScrollY > 10;
      const val = isScrolled ? 'true' : 'false';
      if (prevScrolledState !== val) {
        prevScrolledState = val;
        header.dataset.scrolled = val;
        header.setAttribute('data-scrolled', val);
      }
    };

    const toggleMobileNav = (hide) => {
      const mobileNavs = document.querySelectorAll('[data-stagmenfashion-mobile-nav], .stagmenfashion-mobile-nav, .stagmenfashion-mobile-tabs');
      mobileNavs.forEach((nav) => {
        if (hide) {
          nav.setAttribute('data-hidden', 'true');
          nav.style.setProperty('display', 'none', 'important');
        } else {
          nav.removeAttribute('data-hidden');
          nav.style.removeProperty('display');
        }
      });
    };

    const openDrawer = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (!drawer) return;
      drawer.hidden = false;
      drawer.removeAttribute('hidden');
      document.body.classList.add('pf-drawer-open');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      if (window.__lenis) {
        try { window.__lenis.stop(); } catch(err) {}
      }
      toggleMobileNav(true);
    };

    const closeDrawer = (e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (!drawer) return;
      drawer.hidden = true;
      drawer.setAttribute('hidden', 'true');
      document.body.classList.remove('pf-drawer-open');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      if (window.__lenis) {
        try { window.__lenis.start(); } catch(err) {}
      }
      toggleMobileNav(false);
    };

    openButtons.forEach((button) => button.addEventListener('click', openDrawer));
    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));
    drawer?.addEventListener('click', (event) => {
      if (event.target === drawer) {
        closeDrawer();
        return;
      }
      const accordionBtn = event.target.closest('[data-drawer-accordion-btn]');
      if (accordionBtn) {
        event.preventDefault();
        event.stopPropagation();
        const group = accordionBtn.closest('[data-drawer-accordion], .pf-header__drawer-group, .pf-header__drawer-nav-group');
        const content = group?.querySelector('[data-drawer-accordion-content]');
        const isExpanded = accordionBtn.getAttribute('aria-expanded') === 'true';
        accordionBtn.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        if (content) {
          if (isExpanded) {
            content.hidden = true;
            group?.classList.remove('is-open');
          } else {
            content.hidden = false;
            group?.classList.add('is-open');
          }
        }
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer && !drawer.hidden) {
        closeDrawer();
      }
    });

    const updateCartCount = (count) => {
      const countNodes = document.querySelectorAll('.pf-header__cart-count');
      countNodes.forEach((countNode) => {
        if (count > 0) {
          countNode.textContent = count;
          countNode.removeAttribute('hidden');
          countNode.removeAttribute('aria-hidden');
        } else {
          countNode.textContent = '0';
          countNode.setAttribute('hidden', 'true');
          countNode.setAttribute('aria-hidden', 'true');
        }
      });
    };

    document.addEventListener('cart:update', (event) => {
      let count = 0;
      if (event.detail?.resource?.items !== undefined) {
        count = event.detail.resource.items.length;
      } else if (event.detail?.resource?.item_count !== undefined) {
        count = event.detail.resource.items ? event.detail.resource.items.length : Number(event.detail.resource.item_count);
      } else {
        const comingFromProductForm = event.detail?.data?.source === 'product-form-component';
        const currentCountNode = document.querySelector('.pf-header__cart-count');
        const currentCount = currentCountNode ? Number(currentCountNode.textContent) : 0;
        count = comingFromProductForm ? currentCount + Number(event.detail?.data?.itemCount ?? 0) : Number(event.detail?.data?.itemCount ?? 0);
      }
      updateCartCount(count);
    });

    updateHeaderHeight();
    setScrollState();
    window.addEventListener('scroll', setScrollState, { passive: true });
    window.addEventListener('resize', () => {
      updateHeaderHeight();
      setScrollState();
    }, { passive: true });
    document.addEventListener('dialog:open', setScrollState);
    document.addEventListener('dialog:close', setScrollState);
    document.addEventListener('dialog-open', setScrollState);
    document.addEventListener('dialog-close', setScrollState);

    // -------------------------------------------------------------
    // Clean Structured Story Modal Logic & Instant Preload Fix
    // -------------------------------------------------------------
    const storyModal = document.getElementById('pf-story-modal');
    const openStoryBtns = document.querySelectorAll('[data-open-story-modal]');
    const closeStoryBtns = document.querySelectorAll('[data-story-close]');
    const storyDataScript = document.getElementById('pf-story-data');

    if (storyModal) {
      // Ensure modal is moved to <body> so sticky header & backdrop-filter don't trap or clip it
      if (storyModal.parentElement !== document.body) {
        document.body.appendChild(storyModal);
      }

      let stories = [];
      if (storyDataScript && storyDataScript.textContent.trim()) {
        try {
          const sanitized = storyDataScript.textContent.trim().replace(/,\s*([\]}])/g, '$1');
          stories = JSON.parse(sanitized);
        } catch (e) {
          console.warn('Error parsing story data, using fallback stories', e);
        }
      }

      // Hardened fallback: ensure stories array is never empty so modal ALWAYS opens
      if (!Array.isArray(stories) || stories.length === 0) {
        stories = [
          {
            image: "https://images.unsplash.com/photo-1506630448388-4e683c67ddb0?auto=format&fit=crop&w=1200&q=80",
            tag: "New Arrivals",
            link: "/collections/all",
            btn_text: "Shop Now"
          },
          {
            image: "https://images.unsplash.com/photo-1523381210434-271e8be1f52b?auto=format&fit=crop&w=1200&q=80",
            tag: "Winter Drop",
            link: "/collections/all",
            btn_text: "Shop Now"
          },
          {
            image: "https://images.unsplash.com/photo-1576566588028-4147f3842f27?auto=format&fit=crop&w=1200&q=80",
            tag: "Polo Season",
            link: "/collections/all",
            btn_text: "Shop Now"
          }
        ];
      }

      const progressContainer = storyModal.querySelector('[data-story-progress-container]');
      const storyImage = storyModal.querySelector('[data-story-image]');
      const storyLoader = storyModal.querySelector('[data-story-loader]');
      const storyTag = storyModal.querySelector('[data-story-tag]');
      const storyFooterTag = storyModal.querySelector('[data-story-footer-tag]');
      const storyCta = storyModal.querySelector('[data-story-cta]');
      const storyBtnText = storyModal.querySelector('[data-story-btn-text]');
      const prevBtns = storyModal.querySelectorAll('[data-story-prev], [data-story-tap-prev]');
      const nextBtns = storyModal.querySelectorAll('[data-story-next], [data-story-tap-next]');
      const pauseBtn = storyModal.querySelector('[data-story-pause]');
      const pauseIcon = pauseBtn?.querySelector('.pf-story-modal__pause-icon');
      const playIcon = pauseBtn?.querySelector('.pf-story-modal__play-icon');
      const cardElement = storyModal.querySelector('[data-story-card]');

      let currentIndex = 0;
      let isPaused = false;
      let isImageLoading = false;
      let progressInterval = null;
      const DURATION_MS = 5000;
      const TICK_MS = 30;
      let elapsedMs = 0;

      // Image preload cache to ensure instantaneous transitions
      const preloadedImages = new Map();

      const preloadAllImages = () => {
        stories.forEach((item) => {
          if (item && item.image && !preloadedImages.has(item.image)) {
            const img = new Image();
            img.onload = () => {
              preloadedImages.set(item.image, img);
            };
            img.src = item.image;
          }
        });
      };
      // Story images are preloaded when modal is opened to avoid network contention during initial page load

      // Build Progress Segments
      const buildProgressBars = () => {
        if (!progressContainer) return;
        progressContainer.innerHTML = '';
        stories.forEach((_, idx) => {
          const segment = document.createElement('div');
          segment.className = 'pf-story-modal__progress-segment';
          segment.innerHTML = '<div class="pf-story-modal__progress-fill"></div>';
          segment.addEventListener('click', (e) => {
            e.stopPropagation();
            goToStory(idx);
          });
          progressContainer.appendChild(segment);
        });
      };

      const updateProgressBars = () => {
        const fills = progressContainer?.querySelectorAll('.pf-story-modal__progress-fill');
        if (!fills) return;

        fills.forEach((fill, idx) => {
          if (idx < currentIndex) {
            fill.style.width = '100%';
            fill.classList.add('is-finished');
          } else if (idx === currentIndex) {
            const pct = Math.min((elapsedMs / DURATION_MS) * 100, 100);
            fill.style.width = `${pct}%`;
            fill.classList.remove('is-finished');
          } else {
            fill.style.width = '0%';
            fill.classList.remove('is-finished');
          }
        });
      };

      let activeRenderToken = 0;

      const renderStory = (index) => {
        const item = stories[index];
        if (!item) return;

        const currentToken = ++activeRenderToken;

        // Immediately hide current image to prevent showing old/first image while switching
        if (storyImage) {
          storyImage.classList.remove('is-loaded');
        }

        // Update Text & Link content immediately
        if (storyTag) {
          storyTag.textContent = item.tag || 'Featured';
        }
        if (storyFooterTag) {
          storyFooterTag.textContent = item.tag || 'Featured';
        }
        if (storyCta) {
          storyCta.href = item.link || '#';
        }
        if (storyBtnText) {
          storyBtnText.textContent = item.btn_text || 'Shop Now';
        }

        elapsedMs = 0;
        updateProgressBars();

        // Check if image is already cached
        const preloaded = preloadedImages.get(item.image);
        const isAlreadyComplete = preloaded && preloaded.complete && preloaded.naturalWidth > 0;

        if (isAlreadyComplete) {
          if (storyLoader) storyLoader.classList.remove('is-active');
          isImageLoading = false;
          if (storyImage) {
            storyImage.src = item.image;
            storyImage.classList.add('is-loaded');
          }
        } else {
          // Show loader and pause progress while downloading
          if (storyLoader) storyLoader.classList.add('is-active');
          isImageLoading = true;

          const tempImg = new Image();
          tempImg.onload = () => {
            if (currentToken !== activeRenderToken) return;
            preloadedImages.set(item.image, tempImg);
            if (storyLoader) storyLoader.classList.remove('is-active');
            isImageLoading = false;
            if (storyImage) {
              storyImage.src = item.image;
              storyImage.classList.add('is-loaded');
            }
          };
          tempImg.onerror = () => {
            if (currentToken !== activeRenderToken) return;
            if (storyLoader) storyLoader.classList.remove('is-active');
            isImageLoading = false;
            if (storyImage) {
              const fallbackUrl = "https://images.unsplash.com/photo-1506630448388-4e683c67ddb0?auto=format&fit=crop&w=1200&q=80";
              storyImage.src = fallbackUrl;
              storyImage.classList.add('is-loaded');
            }
          };
          tempImg.src = item.image;
        }
      };

      const startTimer = () => {
        clearInterval(progressInterval);
        progressInterval = setInterval(() => {
          if (isPaused || isImageLoading) return;

          elapsedMs += TICK_MS;
          updateProgressBars();

          if (elapsedMs >= DURATION_MS) {
            if (currentIndex < stories.length - 1) {
              currentIndex++;
              renderStory(currentIndex);
            } else {
              closeStory();
            }
          }
        }, TICK_MS);
      };

      const goToStory = (idx) => {
        if (idx < 0) {
          currentIndex = 0;
        } else if (idx >= stories.length) {
          closeStory();
          return;
        } else {
          currentIndex = idx;
        }
        renderStory(currentIndex);
      };

      const openStory = () => {
        if (storyModal.parentElement !== document.body) {
          document.body.appendChild(storyModal);
        }

        storyModal.removeAttribute('hidden');
        storyModal.hidden = false;
        storyModal.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.classList.add('story-modal-open');

        preloadAllImages();
        buildProgressBars();
        currentIndex = 0;
        isPaused = false;
        renderStory(0);

        requestAnimationFrame(() => {
          storyModal.classList.add('is-active');
        });

        startTimer();
      };

      const closeStory = () => {
        clearInterval(progressInterval);
        storyModal.classList.remove('is-active');
        storyModal.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.classList.remove('story-modal-open');

        setTimeout(() => {
          storyModal.hidden = true;
          storyModal.setAttribute('hidden', '');
          if (storyImage) storyImage.classList.remove('is-loaded');
        }, 280);
      };

      const togglePause = (forcePause) => {
        if (typeof forcePause === 'boolean') {
          isPaused = forcePause;
        } else {
          isPaused = !isPaused;
        }

        if (pauseIcon && playIcon) {
          if (isPaused) {
            pauseIcon.style.display = 'none';
            playIcon.style.display = 'block';
          } else {
            pauseIcon.style.display = 'block';
            playIcon.style.display = 'none';
          }
        }
      };

      // Press & Hold to Pause Feature (Instagram Style)
      let holdTimer = null;
      let isHolding = false;

      if (cardElement) {
        const handleHoldStart = (e) => {
          if (e.target.closest('[data-story-close], [data-story-pause], [data-story-cta], .pf-story-modal__progress-segment')) {
            return;
          }
          holdTimer = setTimeout(() => {
            isHolding = true;
            togglePause(true);
          }, 180);
        };

        const handleHoldEnd = () => {
          clearTimeout(holdTimer);
          if (isHolding) {
            isHolding = false;
            togglePause(false);
          }
        };

        cardElement.addEventListener('mousedown', handleHoldStart);
        cardElement.addEventListener('mouseup', handleHoldEnd);
        cardElement.addEventListener('mouseleave', handleHoldEnd);
        cardElement.addEventListener('touchstart', handleHoldStart, { passive: true });
        cardElement.addEventListener('touchend', handleHoldEnd, { passive: true });
      }

      openStoryBtns.forEach((btn) => btn.addEventListener('click', openStory));
      closeStoryBtns.forEach((btn) => btn.addEventListener('click', closeStory));

      // Document-level event delegation for opening & closing reliably from anywhere
      document.addEventListener('click', (e) => {
        const openBtn = e.target.closest('[data-open-story-modal]');
        if (openBtn) {
          e.preventDefault();
          e.stopPropagation();
          openStory();
          return;
        }

        const closeBtn = e.target.closest('[data-story-close]');
        if (closeBtn && !storyModal.hidden) {
          e.preventDefault();
          e.stopPropagation();
          closeStory();
          return;
        }
      });

      prevBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          goToStory(currentIndex - 1);
        });
      });

      nextBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          goToStory(currentIndex + 1);
        });
      });

      pauseBtn?.addEventListener('click', (e) => {
        e.stopPropagation();
        togglePause();
      });

      // Keyboard support
      window.addEventListener('keydown', (e) => {
        if (storyModal.hidden) return;
        if (e.key === 'Escape') closeStory();
        if (e.key === 'ArrowLeft') goToStory(currentIndex - 1);
        if (e.key === 'ArrowRight') goToStory(currentIndex + 1);
        if (e.key === ' ') {
          e.preventDefault();
          togglePause();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pf-hero]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      const track = root.querySelector('[data-track]');
      const prev = root.querySelector('[data-prev]');
      const next = root.querySelector('[data-next]');
      const dots = Array.from(root.querySelectorAll('[data-dot]'));
      const autoplay = Number(root.dataset.autoplay || 0);
      let index = 0;
      let timer;

      const activate = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      };

      prev?.addEventListener('click', () => activate(index - 1));
      next?.addEventListener('click', () => activate(index + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => activate(Number(dot.dataset.dot))));

      if (autoplay > 0 && slides.length > 1) {
        timer = window.setInterval(() => activate(index + 1), autoplay);
        root.addEventListener('mouseenter', () => window.clearInterval(timer));
        root.addEventListener('mouseleave', () => { timer = window.setInterval(() => activate(index + 1), autoplay); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pf-carousel]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const tabs = root.querySelectorAll('.pf-carousel__tab-btn');
      const panes = root.querySelectorAll('.pf-carousel__pane');

      // Progress bar logic
      const updateProgressBar = (pane) => {
        if (!pane) return;
        const track = pane.querySelector('[data-track]');
        const thumb = pane.querySelector('[data-thumb]');
        if (!track || !thumb) return;

        const update = () => {
          const scrollLeft = track.scrollLeft;
          const maxScroll = track.scrollWidth - track.clientWidth;
          const percentage = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;
          thumb.style.left = `${percentage * 0.7}%`; // thumb width is 30%
        };

        track.addEventListener('scroll', update);
        // Initial run
        update();
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const index = tab.dataset.tabIndex;

          tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
          panes.forEach((p) => p.classList.toggle('is-active', p.dataset.paneIndex === index));
          
          const activePane = root.querySelector(`.pf-carousel__pane.is-active`);
          updateProgressBar(activePane);
        });
      });

      panes.forEach((pane) => {
        updateProgressBar(pane);

        const track = pane.querySelector('[data-track]');
        const prev = root.querySelector('[data-prev]');
        const next = root.querySelector('[data-next]');
        if (track) {
          const step = () => track.querySelector('.pop-card')?.getBoundingClientRect().width || 320;
          prev?.addEventListener('click', () => track.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
          next?.addEventListener('click', () => track.scrollBy({ left: step() * 2, behavior: 'smooth' }));
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initStagProductTemplate(root) {
      if (!root || root._pfInitialized) return;
      root._pfInitialized = true;

      const gallery = root.querySelector('[data-pf-gallery]');
      const slidesRail = root.querySelector('[data-pf-slides]');
      const slides = [...root.querySelectorAll('[data-pf-slide]')];
      const dots = [...root.querySelectorAll('[data-pf-dot]')];
      const sizePills = [...root.querySelectorAll('[data-pf-size-pill]')];
      const swatches = [...root.querySelectorAll('[data-pf-swatch]')];
      const variantIdInput = root.querySelector('[data-pf-variant-id]') || root.querySelector('input[name="id"]');
      const addToBagBtn = root.querySelector('[data-pf-add-to-bag]');
      const buyNowBtn = root.querySelector('[data-pf-buy-now]');
      const addTextEl = root.querySelector('[data-pf-add-text]');
      const buyTextEl = root.querySelector('[data-pf-buy-text]');
      const priceEl = root.querySelector('[data-pf-price]');
      const selectedColorLabel = root.querySelector('[data-pf-selected-color]');
      const tabs = [...root.querySelectorAll('[data-pf-tab]')];
      const panes = [...root.querySelectorAll('[data-pf-pane]')];
      const sizeGuideOpenBtn = root.querySelector('[data-pf-size-guide-open]');
      const modalCloseBtns = [...document.querySelectorAll('[data-pf-modal-close]')];
      const wishlist = root.querySelector('[data-pf-wishlist]');
      const stickyWishlistBtn = root.querySelector('[data-pf-sticky-wishlist]');
      const navPrev = root.querySelector('[data-pf-nav-prev]');
      const navNext = root.querySelector('[data-pf-nav-next]');
      const toastEl = root.querySelector('[data-pf-toast]') || document.querySelector('[data-pf-toast]');
      const toastMsgEl = root.querySelector('[data-pf-toast-text]') || document.querySelector('[data-pf-toast-text]');
      let toastTimer = null;

      const showToastNotification = (msg = 'Selected item is out of stock') => {
        if (!toastEl) return;
        if (toastMsgEl) toastMsgEl.textContent = msg;
        toastEl.removeAttribute('hidden');
        toastEl.classList.add('is-visible');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => {
          toastEl.classList.remove('is-visible');
          setTimeout(() => {
            if (!toastEl.classList.contains('is-visible')) {
              toastEl.setAttribute('hidden', '');
            }
          }, 260);
        }, 2800);
      };

      const stickyBar = root.querySelector('[data-pf-sticky-bar]');
      const stickySizes = [...root.querySelectorAll('[data-pf-sticky-size]')];
      const stickyAddBtn = root.querySelector('[data-pf-sticky-add]');
      const stickyBuyBtn = root.querySelector('[data-pf-sticky-buy]');
      const stickyAddText = root.querySelector('[data-pf-sticky-add-text]');
      const stickyBuyText = root.querySelector('[data-pf-sticky-buy-text]');
      const stickyPriceEl = root.querySelector('[data-pf-sticky-price]');
      const buttonSpinnerHTML = '<span class="pf-btn-spinner" aria-hidden="true"></span>';
      const stickyAddSvgHtml = '<svg class="pf-sticky-action-icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
      const stickyBuySvgHtml = '<svg class="pf-sticky-action-icon" viewBox="0 0 24 24" width="20" height="20" fill="currentColor" stroke="none" aria-hidden="true"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>';

      const setActionButtonLoading = (btn, textEl, isLoading, fallbackHTML = '') => {
        if (!btn) return;
        if (isLoading) {
          if (btn.classList.contains('is-loading')) return;
          btn.dataset.loadingRestoreHtml = textEl ? textEl.innerHTML : (btn.innerHTML || fallbackHTML);
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
          btn.classList.add('is-loading');
          if (textEl) {
            textEl.innerHTML = buttonSpinnerHTML;
          } else {
            btn.innerHTML = buttonSpinnerHTML;
          }
          return;
        }

        const restoreHTML = fallbackHTML || btn.dataset.loadingRestoreHtml || '';
        if (textEl) {
          textEl.innerHTML = restoreHTML;
        } else {
          btn.innerHTML = restoreHTML;
        }
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        delete btn.dataset.loadingRestoreHtml;
      };

      let variantData = [];
      try {
        const variantDataEl = root.querySelector('[id^="VariantData-"]') || document.querySelector('[id^="VariantData-"]');
        if (variantDataEl && variantDataEl.textContent) {
          variantData = JSON.parse(variantDataEl.textContent);
        }
      } catch (e) {
        console.warn('Variant data parse error:', e);
      }

      const variantMap = {};
      if (Array.isArray(variantData)) {
        variantData.forEach((v) => {
          variantMap[v.id] = v;
        });
      }

      let colorImagesMap = {};
      try {
        const colorImagesEl = root.querySelector('[id^="ColorImagesData-"]') || document.querySelector('[id^="ColorImagesData-"]');
        if (colorImagesEl && colorImagesEl.textContent) {
          colorImagesMap = JSON.parse(colorImagesEl.textContent);
        }
      } catch (e) {
        console.warn('Color images parse error:', e);
      }

      function formatMoney(cents, format) {
        if (typeof cents === 'string') cents = parseInt(cents, 10);
        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const cleanFormat = (format || 'RS. {{amount}}').replace(/₹/g, 'RS.');
        const match = cleanFormat.match(placeholderRegex);
        if (!match) return `RS. ${(cents / 100).toLocaleString()}`;

        const placeholder = match[1];
        switch (placeholder) {
          case 'amount':
            value = (cents / 100).toFixed(2);
            break;
          case 'amount_no_decimals':
            value = Math.round(cents / 100).toString();
            break;
          case 'amount_with_comma_separator':
            value = (cents / 100).toFixed(2).replace('.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = Math.round(cents / 100).toString().replace('.', ',');
            break;
          default:
            value = (cents / 100).toFixed(2);
        }

        if (placeholder.includes('comma_separator')) {
          const parts = value.split(',');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          value = parts.join(',');
        } else {
          const parts = value.split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          value = parts.join('.');
        }

        return cleanFormat.replace(placeholderRegex, value);
      }

      // Carousel slides & navigation helpers
      const setActive = (index) => {
        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === index);
        });

        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === index);
          slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
        });
      };

      const getHeaderOffset = () => {
        const rootStyles = getComputedStyle(document.documentElement);
        const bodyStyles = getComputedStyle(document.body);
        const headerGroupHeight = parseFloat(rootStyles.getPropertyValue('--header-group-height')) || 0;
        const headerHeight =
          parseFloat(bodyStyles.getPropertyValue('--header-height')) ||
          parseFloat(rootStyles.getPropertyValue('--header-height')) ||
          0;
        const headerElem = document.querySelector('.header-section, .shopify-section-group-header-group, header');
        const headerElemHeight = headerElem ? headerElem.getBoundingClientRect().height : 0;

        const effectiveHeaderHeight = headerGroupHeight || headerHeight || headerElemHeight || 66;
        return effectiveHeaderHeight + 8;
      };

      const goToSlide = (index, allowVerticalScroll = true) => {
        const slide = slides[index];
        if (!slide) return;
        if (window.innerWidth >= 990) {
          if (allowVerticalScroll) {
            const headerOffset = getHeaderOffset();
            if (index === 0 || index === 1) {
              const sectionTop = root.getBoundingClientRect().top + window.pageYOffset;
              window.scrollTo({
                top: Math.max(0, sectionTop - headerOffset),
                behavior: 'smooth'
              });
            } else {
              const slideTop = slide.getBoundingClientRect().top + window.pageYOffset;
              window.scrollTo({
                top: Math.max(0, slideTop - headerOffset),
                behavior: 'smooth'
              });
            }
          }
        } else if (slidesRail) {
          const targetLeft = slide.offsetLeft - (slidesRail.clientWidth - slide.clientWidth) / 2;
          slidesRail.scrollTo({
            left: Math.max(0, targetLeft),
            behavior: 'smooth'
          });
        }
        setActive(index);
      };

      const goToMediaId = (mediaId, allowVerticalScroll = true) => {
        if (!mediaId) return;
        const index = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
        if (index >= 0) {
          goToSlide(index, allowVerticalScroll);
        }
      };

      const getNearestIndex = () => {
        const rail = slidesRail || gallery;
        if (!rail) return 0;
        const rect = rail.getBoundingClientRect();
        const railCenter = rect.left + rect.width / 2;
        let bestIndex = 0;
        let bestDistance = Infinity;

        slides.forEach((slide, index) => {
          const slideRect = slide.getBoundingClientRect();
          const slideCenter = slideRect.left + slideRect.width / 2;
          const distance = Math.abs(slideCenter - railCenter);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestIndex = index;
          }
        });

        return bestIndex;
      };

      const updateProductImageForColor = (colorName) => {
        if (!colorName) return;
        const cleanColor = colorName.trim().toLowerCase();

        let targetImg = null;
        let targetMediaId = null;

        // 1. Check direct active swatch attribute
        const activeSwatch = swatches.find((s) => (s.dataset.colorName || '').trim().toLowerCase() === cleanColor);
        if (activeSwatch) {
          if (activeSwatch.dataset.colorImage) targetImg = activeSwatch.dataset.colorImage;
          if (activeSwatch.dataset.mediaId) targetMediaId = activeSwatch.dataset.mediaId;
        }

        // 2. Check colorImagesMap
        if (!targetImg && colorImagesMap) {
          if (colorImagesMap[colorName]) {
            targetImg = colorImagesMap[colorName];
          } else {
            const foundKey = Object.keys(colorImagesMap).find((k) => k.trim().toLowerCase() === cleanColor);
            if (foundKey) targetImg = colorImagesMap[foundKey];
          }
        }

        // 3. Check variantData
        if (Array.isArray(variantData)) {
          const vMatch = variantData.find((v) => {
            const o1 = (v.option1 || '').trim().toLowerCase();
            const o2 = (v.option2 || '').trim().toLowerCase();
            const o3 = (v.option3 || '').trim().toLowerCase();
            const opts = (v.options || []).map((o) => String(o).trim().toLowerCase());
            return (o1 === cleanColor || o2 === cleanColor || o3 === cleanColor || opts.includes(cleanColor)) && (v.featured_image || v.featured_media || v.image);
          });
          if (vMatch) {
            if (!targetMediaId && (vMatch.featured_media?.id || vMatch.featured_image?.id)) {
              targetMediaId = vMatch.featured_media?.id || vMatch.featured_image?.id;
            }
            if (!targetImg) {
              const imgObj = vMatch.featured_image || vMatch.featured_media || vMatch.image;
              targetImg = typeof imgObj === 'string' ? imgObj : (imgObj?.src || imgObj?.preview_image?.src);
            }
          }
        }

        if (targetImg && typeof targetImg === 'string' && targetImg.trim() !== '') {
          if (targetImg.startsWith('//')) targetImg = 'https:' + targetImg;

          // Update sticky bar image
          const stickyImg = root.querySelector('[data-pf-sticky-image]');
          if (stickyImg) {
            stickyImg.src = targetImg;
          }

          // Update / Scroll secondary slide
          let matchingSlideIndex = -1;
          if (targetMediaId) {
            matchingSlideIndex = slides.findIndex((slide, idx) => idx > 0 && slide.dataset.mediaId === String(targetMediaId));
          }

          if (matchingSlideIndex < 0) {
            matchingSlideIndex = slides.findIndex((slide, idx) => {
              if (idx === 0) return false;
              const img = slide.querySelector('img');
              const alt = (img?.alt || '').trim().toLowerCase();
              const src = img?.src || '';
              return (alt && alt.includes(cleanColor)) || (src && (src === targetImg || targetImg.includes(src)));
            });
          }

          if (matchingSlideIndex >= 0) {
            goToSlide(matchingSlideIndex, true);
          } else {
            const secondaryImg = root.querySelector('.pf-gallery__secondary img');
            if (secondaryImg) {
              secondaryImg.removeAttribute('srcset');
              secondaryImg.removeAttribute('sizes');
              secondaryImg.src = targetImg;
              secondaryImg.srcset = `${targetImg} 1x, ${targetImg} 2x`;
              const firstSecondarySlide = root.querySelector('.pf-gallery__secondary [data-pf-slide]');
              if (firstSecondarySlide) {
                const slideIdx = parseInt(firstSecondarySlide.dataset.slideIndex || '1', 10);
                goToSlide(slideIdx, true);
              }
            }
          }
        }
      };

      const syncVariant = (variantId) => {
        if (variantIdInput && variantId) {
          variantIdInput.value = variantId;
        }

        if (variantId && window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({ path: url.href }, '', url.href);
        }

        const v = variantMap[variantId];
        if (v) {
          const available = v.available === true || v.available === 'true';

          // Update Add / Buy button state
          if (addToBagBtn) {
            addToBagBtn.disabled = false;
            addToBagBtn.classList.toggle('is-sold-out', !available);
            if (!available) {
              addToBagBtn.setAttribute('aria-disabled', 'true');
              addToBagBtn.setAttribute('data-sold-out', 'true');
            } else {
              addToBagBtn.removeAttribute('aria-disabled');
              addToBagBtn.removeAttribute('data-sold-out');
            }
            if (addTextEl) {
              addTextEl.textContent = 'ADD TO BAG';
            }
          }
          if (buyNowBtn) {
            buyNowBtn.disabled = !available;
            if (!available) {
              buyNowBtn.setAttribute('aria-disabled', 'true');
              buyNowBtn.classList.remove('magic-buy-now');
            } else {
              buyNowBtn.removeAttribute('aria-disabled');
              buyNowBtn.classList.add('magic-buy-now');
            }
            if (buyTextEl) {
              buyTextEl.textContent = 'BUY NOW';
            }
          }

          if (stickyAddBtn) {
            stickyAddBtn.disabled = false;
            stickyAddBtn.classList.toggle('is-sold-out', !available);
            stickyAddBtn.setAttribute('title', available ? 'Add to bag' : 'Sold out - Add to wishlist');
            stickyAddBtn.setAttribute('aria-label', available ? 'Add to bag' : 'Sold out - Add to wishlist');
            if (!available) {
              stickyAddBtn.setAttribute('aria-disabled', 'true');
              stickyAddBtn.setAttribute('data-sold-out', 'true');
            } else {
              stickyAddBtn.removeAttribute('aria-disabled');
              stickyAddBtn.removeAttribute('data-sold-out');
            }
          }
          if (stickyBuyBtn) {
            stickyBuyBtn.disabled = !available;
            stickyBuyBtn.setAttribute('title', available ? 'Buy now' : 'Sold out');
            stickyBuyBtn.setAttribute('aria-label', available ? 'Buy now' : 'Sold out');
            if (!available) {
              stickyBuyBtn.setAttribute('aria-disabled', 'true');
              stickyBuyBtn.classList.remove('magic-buy-now');
            } else {
              stickyBuyBtn.removeAttribute('aria-disabled');
              stickyBuyBtn.classList.add('magic-buy-now');
            }
          }

          // Update sticky image
          const stickyImg = root.querySelector('[data-pf-sticky-image]');
          if (stickyImg) {
            if (v.featured_image && v.featured_image.src) {
              stickyImg.src = v.featured_image.src;
            } else if (v.featured_media && (v.featured_media.preview_image || v.featured_media.src)) {
              stickyImg.src = v.featured_media.preview_image?.src || v.featured_media.src || v.featured_media.preview_image;
            }
          }

          // Update Price
          if (priceEl && v.price) {
            const moneyFormat = root.dataset.moneyFormat || 'RS. {{amount}}';
            const priceText = formatMoney(v.price, moneyFormat);
            const priceValEl = priceEl.querySelector('.price') || priceEl;
            if (priceValEl) priceValEl.textContent = priceText;

            const compareValEl = priceEl.querySelector('.compare-at-price');
            if (compareValEl && v.compare_at_price && v.compare_at_price > v.price) {
              compareValEl.textContent = formatMoney(v.compare_at_price, moneyFormat);
            }

            if (stickyPriceEl) {
              stickyPriceEl.textContent = priceText;
            }

            const stickyCompareEl = root.querySelector('[data-pf-sticky-compare-price]');
            if (stickyCompareEl) {
              if (v.compare_at_price && v.compare_at_price > v.price) {
                stickyCompareEl.textContent = formatMoney(v.compare_at_price, moneyFormat);
                stickyCompareEl.style.display = 'inline';
              } else {
                stickyCompareEl.style.display = 'none';
              }
            }
          }

          if (v.featured_media && v.featured_media.id) {
            goToMediaId(v.featured_media.id, true);
          }
        }
      };

      const normalizeOpt = (str) => {
        if (str === null || str === undefined) return '';
        return String(str).trim().toLowerCase();
      };

      const isOptionCombinationAvailable = (color, size) => {
        if (!variantData || !variantData.length) return true;
        const targetColor = normalizeOpt(color);
        const targetSize = normalizeOpt(size);

        const matching = variantData.filter((v) => {
          const vOpt1 = normalizeOpt(v.option1);
          const vOpt2 = normalizeOpt(v.option2);
          const vOpt3 = normalizeOpt(v.option3);
          const vOpts = Array.isArray(v.options) ? v.options.map(normalizeOpt) : [vOpt1, vOpt2, vOpt3];

          const matchColor = !targetColor || vOpt1 === targetColor || vOpt2 === targetColor || vOpt3 === targetColor || vOpts.includes(targetColor);
          const matchSize = !targetSize || vOpt1 === targetSize || vOpt2 === targetSize || vOpt3 === targetSize || vOpts.includes(targetSize);

          return matchColor && matchSize;
        });

        if (matching.length === 0) return false;
        return matching.some((v) => v.available === true || v.available === 'true');
      };

      const findVariant = (color, size) => {
        if (!variantData || !variantData.length) {
          const currentId = variantIdInput?.value || root.querySelector('[data-pf-variant-id]')?.value;
          if (currentId) return { id: currentId, available: true };
          return null;
        }

        const targetColor = normalizeOpt(color);
        const targetSize = normalizeOpt(size);

        // Pass 1: exact match with available=true
        let matched = variantData.find((v) => {
          const vOpt1 = normalizeOpt(v.option1);
          const vOpt2 = normalizeOpt(v.option2);
          const vOpt3 = normalizeOpt(v.option3);
          const vOpts = Array.isArray(v.options) ? v.options.map(normalizeOpt) : [vOpt1, vOpt2, vOpt3];

          const matchColor = !targetColor || vOpt1 === targetColor || vOpt2 === targetColor || vOpt3 === targetColor || vOpts.includes(targetColor);
          const matchSize = !targetSize || vOpt1 === targetSize || vOpt2 === targetSize || vOpt3 === targetSize || vOpts.includes(targetSize);

          return matchColor && matchSize && (v.available === true || v.available === 'true');
        });

        if (matched) return matched;

        // Pass 2: exact match even if unavailable
        matched = variantData.find((v) => {
          const vOpt1 = normalizeOpt(v.option1);
          const vOpt2 = normalizeOpt(v.option2);
          const vOpt3 = normalizeOpt(v.option3);
          const vOpts = Array.isArray(v.options) ? v.options.map(normalizeOpt) : [vOpt1, vOpt2, vOpt3];

          const matchColor = !targetColor || vOpt1 === targetColor || vOpt2 === targetColor || vOpt3 === targetColor || vOpts.includes(targetColor);
          const matchSize = !targetSize || vOpt1 === targetSize || vOpt2 === targetSize || vOpt3 === targetSize || vOpts.includes(targetSize);

          return matchColor && matchSize;
        });

        if (matched) return matched;

        // Pass 3: match color only
        if (targetColor) {
          matched = variantData.find((v) => {
            const vOpt1 = normalizeOpt(v.option1);
            const vOpt2 = normalizeOpt(v.option2);
            const vOpt3 = normalizeOpt(v.option3);
            const vOpts = Array.isArray(v.options) ? v.options.map(normalizeOpt) : [vOpt1, vOpt2, vOpt3];
            return vOpt1 === targetColor || vOpt2 === targetColor || vOpt3 === targetColor || vOpts.includes(targetColor);
          });
        }

        // Pass 4: match size only
        if (!matched && targetSize) {
          matched = variantData.find((v) => {
            const vOpt1 = normalizeOpt(v.option1);
            const vOpt2 = normalizeOpt(v.option2);
            const vOpt3 = normalizeOpt(v.option3);
            const vOpts = Array.isArray(v.options) ? v.options.map(normalizeOpt) : [vOpt1, vOpt2, vOpt3];
            return vOpt1 === targetSize || vOpt2 === targetSize || vOpt3 === targetSize || vOpts.includes(targetSize);
          });
        }

        return matched || variantData[0] || null;
      };

      let selectedColor = '';
      const activeSwatch = root.querySelector('[data-pf-swatch].is-active') || swatches[0];
      if (activeSwatch && activeSwatch.dataset.colorName) {
        selectedColor = activeSwatch.dataset.colorName;
      }

      let selectedSize = '';
      const activeSizePill = root.querySelector('[data-pf-size-pill].is-active') || sizePills[0];
      if (activeSizePill) {
        selectedSize = (activeSizePill.dataset.size || activeSizePill.dataset.value || activeSizePill.dataset.pfSizePill || activeSizePill.textContent || '').trim();
      }

      const updateOptionStates = (isInitial = false) => {
        // 1. Update size pills availability
        sizePills.forEach((pill) => {
          const sizeVal = (pill.dataset.size || pill.dataset.value || pill.dataset.pfSizePill || pill.textContent || '').trim();
          const isAvail = isOptionCombinationAvailable(selectedColor, sizeVal);
          pill.classList.toggle('is-unavailable', !isAvail);
          pill.setAttribute('aria-disabled', isAvail ? 'false' : 'true');
          if (!isAvail) {
            pill.setAttribute('data-sold-out', 'true');
          } else {
            pill.removeAttribute('data-sold-out');
          }
        });

        // 2. Update sticky sizes availability
        stickySizes.forEach((sb) => {
          const sizeVal = (sb.dataset.pfStickySize || sb.textContent || '').trim();
          const isAvail = isOptionCombinationAvailable(selectedColor, sizeVal);
          sb.classList.toggle('is-unavailable', !isAvail);
          sb.setAttribute('aria-disabled', isAvail ? 'false' : 'true');
        });

        // 3. Update size label
        const selectedSizeLabel = root.querySelector('[data-pf-selected-size]');
        if (selectedSizeLabel) {
          if (selectedSize) {
            const isAvail = isOptionCombinationAvailable(selectedColor, selectedSize);
            if (!isAvail) {
              selectedSizeLabel.innerHTML = `${selectedSize} <span class="pf-out-of-stock-tag">OUT OF STOCK</span>`;
            } else {
              selectedSizeLabel.textContent = selectedSize;
            }
          } else {
            const currentVarId = variantIdInput?.value || root.querySelector('[data-pf-variant-id]')?.value;
            const currentVar = variantMap[currentVarId] || (variantData && variantData[0]);
            const isAvail = currentVar ? (currentVar.available === true || currentVar.available === 'true') : true;
            if (!isAvail) {
              selectedSizeLabel.innerHTML = `<span class="pf-out-of-stock-tag">OUT OF STOCK</span>`;
            } else {
              selectedSizeLabel.innerHTML = '';
            }
          }
        }

        // 4. Update color label
        if (selectedColorLabel && selectedColor) {
          selectedColorLabel.textContent = selectedColor;
        }

        // 5. Update image for selected color
        if (!isInitial) {
          updateProductImageForColor(selectedColor);
        }

        // 6. Find matching variant & sync price, button state, input
        const matchedVariant = findVariant(selectedColor, selectedSize);
        if (matchedVariant) {
          syncVariant(matchedVariant.id);
          if (wishlist) {
            wishlist.dataset.productVariantId = String(matchedVariant.id);
            wishlist.dataset.productColor = selectedColor || '';
            wishlist.dataset.productSize = selectedSize || '';
          }
          if (stickyWishlistBtn) {
            stickyWishlistBtn.dataset.productVariantId = String(matchedVariant.id);
            stickyWishlistBtn.dataset.productColor = selectedColor || '';
            stickyWishlistBtn.dataset.productSize = selectedSize || '';
          }
        }
      };

      // Size Pills Selection
      sizePills.forEach((pill) => {
        pill.addEventListener('click', (e) => {
          e.preventDefault();
          sizePills.forEach((p) => {
            p.classList.remove('is-active');
            p.classList.remove('is-selected');
          });
          pill.classList.add('is-active');
          pill.classList.add('is-selected');

          selectedSize = (pill.dataset.size || pill.dataset.value || pill.dataset.pfSizePill || pill.textContent || '').trim();
          if (wishlist) {
            wishlist.dataset.productSize = selectedSize;
            if (selectedColor) wishlist.dataset.productColor = selectedColor;
          }
          if (stickyWishlistBtn) {
            stickyWishlistBtn.dataset.productSize = selectedSize;
            if (selectedColor) stickyWishlistBtn.dataset.productColor = selectedColor;
          }

          // Sync sticky size buttons
          stickySizes.forEach((sb) => {
            const sVal = (sb.dataset.pfStickySize || sb.textContent || '').trim().toLowerCase();
            sb.classList.toggle('is-active', sVal === selectedSize.toLowerCase());
          });

          updateOptionStates(false);
        });
      });

      // Color Swatches Selection
      swatches.forEach((swatch) => {
        swatch.addEventListener('click', (e) => {
          e.preventDefault();
          swatches.forEach((s) => {
            s.classList.remove('is-active');
            s.setAttribute('aria-pressed', 'false');
          });
          swatch.classList.add('is-active');
          swatch.setAttribute('aria-pressed', 'true');

          selectedColor = swatch.dataset.colorName || '';
          if (wishlist) {
            wishlist.dataset.productColor = selectedColor;
            if (selectedSize) wishlist.dataset.productSize = selectedSize;
          }
          if (stickyWishlistBtn) {
            stickyWishlistBtn.dataset.productColor = selectedColor;
            if (selectedSize) stickyWishlistBtn.dataset.productSize = selectedSize;
          }

          updateOptionStates(false);
        });
      });

      // Sticky size buttons click listener
      stickySizes.forEach((sb) => {
        sb.addEventListener('click', (e) => {
          e.preventDefault();
          const sVal = (sb.dataset.pfStickySize || sb.textContent || '').trim().toLowerCase();
          const matchPill = sizePills.find((p) => (p.dataset.size || p.dataset.value || p.dataset.pfSizePill || p.textContent || '').trim().toLowerCase() === sVal);
          if (matchPill) {
            matchPill.click();
          }
        });
      });

      // Run initial update on load
      updateOptionStates(true);

      // Add To Bag Action Handler
      const handleAddToCart = async (btn, textEl) => {
        let variantId = variantIdInput?.value || root.querySelector('[data-pf-variant-id]')?.value;
        if (!variantId) {
          const activePill = root.querySelector('[data-pf-size-pill].is-active');
          if (activePill?.dataset.variantId) {
            variantId = activePill.dataset.variantId;
          }
        }
        if (!variantId && Array.isArray(variantData) && variantData.length > 0) {
          variantId = variantData[0].id;
        }
        if (btn?.disabled || btn?.classList.contains('is-loading')) return;

        const v = variantMap[variantId];
        if (!variantId || (v && (v.available === false || v.available === 'false'))) {
          // Add sold out item to wishlist
          try {
            const currentHandle = root.dataset.productHandle || window.location.pathname.split('/products/')[1]?.split('?')[0]?.replace(/\/$/, '') || '{{ product.handle }}';
            const productTitle = root.querySelector('.pf-buybox__title')?.textContent?.trim() || '{{ product.title | escape }}';
            const rawPrice = v ? (v.price || '{{ current_variant.price }}') : '{{ current_variant.price }}';
            const formattedPrice = formatMoney(rawPrice, root.dataset.moneyFormat || 'RS. {{amount}}');
            const targetImgEl = root.querySelector('.pf-gallery__main img') || root.querySelector('.pf-gallery__secondary img');
            const currentImage = (v && (v.featured_image?.src || v.featured_media?.preview_image?.src || v.featured_media?.src)) || targetImgEl?.src || '{{ product.featured_image | image_url: width: 300 }}';

            let list = JSON.parse(localStorage.getItem('wishlist') || '[]');
            const itemIndex = list.findIndex((item) => item.handle === currentHandle);
            const itemObj = {
              handle: currentHandle,
              id: '{{ product.id }}',
              title: productTitle,
              price: formattedPrice,
              image: currentImage,
              size: selectedSize || '',
              color: selectedColor || '',
              variantId: String(variantId || ''),
              available: false
            };
            if (itemIndex > -1) {
              list[itemIndex] = { ...list[itemIndex], ...itemObj };
            } else {
              list.push(itemObj);
            }
            localStorage.setItem('wishlist', JSON.stringify(list));
            document.dispatchEvent(new CustomEvent('wishlist:update'));
            if (typeof window.updateHeartStates === 'function') {
              window.updateHeartStates(document);
            }
          } catch (e) {
            console.error('Failed to add sold-out product to wishlist:', e);
          }

          showToastNotification('Product is sold out. Added to your Wishlist');
          return;
        }

        const mainAddBtn = addToBagBtn || btn;
        const mainAddText = addTextEl || textEl;
        const originalText = mainAddText ? mainAddText.innerHTML : 'ADD TO BAG';
        const originalStickyText = stickyAddText ? stickyAddText.innerHTML : stickyAddSvgHtml;

        setActionButtonLoading(mainAddBtn, mainAddText, true, originalText);
        if (stickyAddBtn) setActionButtonLoading(stickyAddBtn, stickyAddText, true, originalStickyText);

        const cartAddUrl = window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js';
        const cartUrl = window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js';

        try {
          const cartItemsComponents = document.querySelectorAll('cart-items-component, [data-section-id]');
          const sectionIds = [];
          cartItemsComponents.forEach((item) => {
            if (item.dataset.sectionId && !sectionIds.includes(item.dataset.sectionId)) {
              sectionIds.push(item.dataset.sectionId);
            }
          });

          const postBody = {
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          };

          if (sectionIds.length > 0) {
            postBody.sections = sectionIds.join(',');
            postBody.sections_url = window.location.pathname;
          }

          const response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json, text/javascript, */*',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(postBody)
          });

          if (!response.ok) {
            const errData = await response.json().catch(() => ({}));
            throw new Error(errData.description || 'Add to cart failed');
          }

          const addData = await response.json();

          let cartData = null;
          try {
            const cartRes = await fetch(cartUrl);
            if (cartRes.ok) cartData = await cartRes.json();
          } catch (e) {}

          const finalCart = cartData || addData;

          const eventDetail = {
            data: finalCart,
            resource: finalCart,
            sourceId: 'pf-product-template',
            metadata: {
              itemCount: finalCart.item_count || 1
            },
            sections: addData.sections
          };

          document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: eventDetail }));
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: eventDetail }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: eventDetail }));
          window.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: eventDetail }));

          // Open cart drawer
          setTimeout(() => {
            const cartDrawer = document.querySelector('cart-drawer-component, cart-drawer, #cart-drawer, [data-cart-drawer]');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else if (cartDrawer && typeof cartDrawer.showDialog === 'function') {
              cartDrawer.showDialog();
            } else {
              const trigger = document.querySelector('[data-testid="cart-drawer-trigger"], [data-open-cart-drawer], .stagmenfashion-header__cart-button, .pf-header__cart-button');
              if (trigger) {
                trigger.click();
              } else {
                window.location.href = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart` : '/cart';
              }
            }
          }, 120);

          setTimeout(() => {
            setActionButtonLoading(mainAddBtn, mainAddText, false, originalText);
            if (stickyAddBtn) setActionButtonLoading(stickyAddBtn, stickyAddText, false, originalStickyText);
          }, 600);
        } catch (err) {
          console.warn('Add to cart fetch failed, falling back to form submit:', err);
          const form = root.querySelector('form[action*="/cart/add"]') || root.querySelector('.pf-buybox__form');
          if (form) {
            form.submit();
          } else {
            setActionButtonLoading(mainAddBtn, mainAddText, false, originalText);
            if (stickyAddBtn) setActionButtonLoading(stickyAddBtn, stickyAddText, false, originalStickyText);
          }
        }
      };

      // Reset all loading buttons in root
      const resetAllButtonLoadingStates = () => {
        const isAvail = !addToBagBtn || !addToBagBtn.disabled;
        const originalText = addTextEl ? (addTextEl.dataset.defaultText || 'ADD TO BAG') : 'ADD TO BAG';
        const originalBuyText = buyTextEl ? (buyTextEl.dataset.defaultText || (isAvail ? 'BUY NOW' : 'SOLD OUT')) : (isAvail ? 'BUY NOW' : 'SOLD OUT');
        const originalStickyText = stickyAddText ? (stickyAddText.dataset.defaultText || stickyAddSvgHtml) : stickyAddSvgHtml;
        setActionButtonLoading(addToBagBtn, addTextEl, false, originalText);
        setActionButtonLoading(buyNowBtn, buyTextEl, false, originalBuyText);
        if (stickyAddBtn) setActionButtonLoading(stickyAddBtn, stickyAddText, false, originalStickyText);
        if (stickyBuyBtn) setActionButtonLoading(stickyBuyBtn, stickyBuyText, false, stickyBuySvgHtml);

        root.querySelectorAll('.pf-btn.is-loading, .pf-sticky-btn.is-loading, .pf-sticky-icon-btn.is-loading').forEach((b) => {
          b.classList.remove('is-loading');
          b.removeAttribute('aria-busy');
          b.disabled = !isAvail;
          if (b.dataset.loadingRestoreHtml) {
            b.innerHTML = b.dataset.loadingRestoreHtml;
            delete b.dataset.loadingRestoreHtml;
          }
        });
      };

      // Buy Now Action Handler
      const handleBuyNow = (btn, textEl) => {
        let variantId = variantIdInput?.value || root.querySelector('[data-pf-variant-id]')?.value;
        if (!variantId) {
          const activePill = root.querySelector('[data-pf-size-pill].is-active');
          if (activePill?.dataset.variantId) {
            variantId = activePill.dataset.variantId;
          }
        }
        if (!variantId && Array.isArray(variantData) && variantData.length > 0) {
          variantId = variantData[0].id;
        }
        if (btn?.disabled || btn?.classList.contains('is-loading')) return;

        const v = variantMap[variantId];
        if (!variantId || (v && (v.available === false || v.available === 'false'))) {
          showToastNotification('This product variant is currently sold out');
          return;
        }

        if (btn) {
          setActionButtonLoading(btn, textEl || buyTextEl, true, btn === stickyBuyBtn ? stickyBuySvgHtml : 'BUY NOW');
        }

        const rootUrl = window.Shopify?.routes?.root || '/';
        const cleanRoot = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';
        window.location.href = `${cleanRoot}cart/${variantId}:1`;

        // Automatically reset loading after 1.2s so if user returns via browser back button (bfcache), button is restored
        setTimeout(() => {
          resetAllButtonLoadingStates();
        }, 1200);
      };

      // Wire up Add To Bag button
      if (addToBagBtn) {
        addToBagBtn.addEventListener('click', (e) => {
          e.preventDefault();
          handleAddToCart(addToBagBtn, addTextEl);
        });
      }

      // Wire up Buy Now button
      if (buyNowBtn) {
        buyNowBtn.addEventListener('click', (e) => {
          e.preventDefault();
          handleBuyNow(buyNowBtn);
        });
      }

      // Wire up Sticky Add & Buy
      if (stickyAddBtn) {
        stickyAddBtn.addEventListener('click', (e) => {
          e.preventDefault();
          handleAddToCart(stickyAddBtn, stickyAddText);
        });
      }

      if (stickyBuyBtn) {
        stickyBuyBtn.addEventListener('click', (e) => {
          e.preventDefault();
          handleBuyNow(stickyBuyBtn, stickyBuyText);
        });
      }

      // Tabs Switching
      tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          const target = tab.dataset.pfTab;
          if (!target) return;

          tabs.forEach((t) => {
            const active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panes.forEach((pane) => {
            const active = pane.dataset.pfPane === target;
            pane.classList.toggle('is-active', active);
            if (active) {
              pane.removeAttribute('hidden');
              if (target === 'reviews') {
                window.dispatchEvent(new Event('resize'));
              }
            } else {
              pane.setAttribute('hidden', '');
            }
          });
        });
      });

      // Reviews Tab Write Review Button Handler
      const reviewOpenBtns = [...root.querySelectorAll('[data-pf-reviews-open]')];
      reviewOpenBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const jmWidget = root.querySelector('#judgeme_product_reviews, .jdgm-widget, .jdgm-rev-wid');
          if (jmWidget) {
            const writeRevBtn = jmWidget.querySelector('.jdgm-write-rev-link, .jdgm-rev-mgr__write-rev-btn, [data-testid="write-review-button"]');
            if (writeRevBtn) {
              writeRevBtn.click();
              return;
            }
            if (typeof window.jdgm?.openWriteReviewModal === 'function') {
              window.jdgm.openWriteReviewModal(root.dataset.productId || '{{ selected_product.id }}');
              return;
            }
            jmWidget.classList.toggle('jdgm-form-open');
          }
        });
      });

      // Size Guide Modal Open / Close
      const openSizeGuide = () => {
        const modal = document.getElementById('pf-size-guide-modal') || document.querySelector('[data-pf-size-guide-modal]');
        if (modal) {
          modal.style.display = 'flex';
          modal.removeAttribute('hidden');
          requestAnimationFrame(() => {
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
          });
          document.body.style.overflow = 'hidden';
        }
      };

      const closeSizeGuide = () => {
        const modal = document.getElementById('pf-size-guide-modal') || document.querySelector('[data-pf-size-guide-modal]');
        if (modal) {
          modal.classList.remove('is-open');
          modal.setAttribute('aria-hidden', 'true');
          setTimeout(() => {
            if (!modal.classList.contains('is-open')) {
              modal.style.display = 'none';
              modal.setAttribute('hidden', '');
            }
          }, 220);
          document.body.style.overflow = '';
        }
      };

      const sizeGuideOpenBtns = [...root.querySelectorAll('[data-pf-size-guide-open]')];
      sizeGuideOpenBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          if (btn.disabled) return;
          e.preventDefault();
          openSizeGuide();
        });
      });

      // Size Guide Unit Switcher (IN / CM)
      const unitButtons = [...root.querySelectorAll('.pf-unit-btn')];
      const sizeTable = root.querySelector('[data-pf-size-table]');

      unitButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const unit = btn.dataset.unit;
          if (!unit) return;

          unitButtons.forEach((b) => {
            const isActive = b === btn;
            b.classList.toggle('is-active', isActive);
            b.setAttribute('aria-checked', isActive ? 'true' : 'false');
          });
          if (sizeTable) {
            sizeTable.dataset.activeUnit = unit;
          }

          const cells = root.querySelectorAll('td[data-val-cm]');
          cells.forEach((cell) => {
            cell.textContent = unit === 'in' ? cell.dataset.valIn : cell.dataset.valCm;
          });
        });
      });

      modalCloseBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          closeSizeGuide();
        });
      });

      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-pf-modal-close]')) {
          e.preventDefault();
          closeSizeGuide();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const modal = document.getElementById('pf-size-guide-modal') || document.querySelector('[data-pf-size-guide-modal]');
          if (modal && modal.classList.contains('is-open')) {
            closeSizeGuide();
          }
        }
      });

      // Carousel slides scroll & dot listeners
      if (slidesRail && slides.length) {
        let raf = 0;
        slidesRail.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => setActive(getNearestIndex()));
        });

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => goToSlide(index));
        });

        navPrev?.addEventListener('click', () => {
          const current = slides.findIndex((s) => s.classList.contains('is-active'));
          goToSlide(Math.max(0, current - 1));
        });

        navNext?.addEventListener('click', () => {
          const current = slides.findIndex((s) => s.classList.contains('is-active'));
          goToSlide(Math.min(slides.length - 1, current + 1));
        });

        setActive(0);
      }

      // Related & Reallife carousel handlers
      const relatedTrack = root.querySelector('[data-pf-related-track]');
      const relatedPrev = root.querySelector('[data-pf-related-prev]');
      const relatedNext = root.querySelector('[data-pf-related-next]');

      if (relatedTrack && relatedPrev && relatedNext) {
        const getRelatedStep = () => {
          const firstCard = relatedTrack.querySelector('.pf-product-template__related-card');
          if (!firstCard) return relatedTrack.clientWidth;
          const gap = parseFloat(window.getComputedStyle(relatedTrack).columnGap || 0);
          return firstCard.getBoundingClientRect().width + gap;
        };

        const updateRelatedControls = () => {
          const maxScroll = relatedTrack.scrollWidth - relatedTrack.clientWidth;
          const canScroll = maxScroll > 1;
          relatedPrev.disabled = !canScroll || relatedTrack.scrollLeft <= 1;
          relatedNext.disabled = !canScroll || relatedTrack.scrollLeft >= maxScroll - 1;
        };

        relatedPrev.addEventListener('click', () => {
          relatedTrack.scrollBy({ left: -getRelatedStep(), behavior: 'smooth' });
        });

        relatedNext.addEventListener('click', () => {
          relatedTrack.scrollBy({ left: getRelatedStep(), behavior: 'smooth' });
        });

        let relatedRaf = 0;
        relatedTrack.addEventListener('scroll', () => {
          cancelAnimationFrame(relatedRaf);
          relatedRaf = requestAnimationFrame(updateRelatedControls);
        });

        window.addEventListener('resize', updateRelatedControls);
        updateRelatedControls();
      }

      // Sync wishlist bookmark button states
      const syncAllWishlistStates = () => {
        try {
          const list = JSON.parse(localStorage.getItem('wishlist') || '[]');
          const currentHandle =
            wishlist?.dataset.productHandle ||
            root?.dataset.productHandle ||
            window.location.pathname.split('/products/')[1]?.split('?')[0]?.replace(/\/$/, '');
          if (!currentHandle) return;

          const isSaved = list.some((i) => i.handle === currentHandle);
          if (wishlist) {
            wishlist.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
            wishlist.setAttribute('aria-label', isSaved ? 'Remove from wishlist' : 'Add to wishlist');
            wishlist.classList.toggle('is-saved', isSaved);
            wishlist.classList.toggle('is-active', isSaved);
          }
          if (stickyWishlistBtn) {
            stickyWishlistBtn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
            stickyWishlistBtn.setAttribute('aria-label', isSaved ? 'Remove from wishlist' : 'Add to wishlist');
            stickyWishlistBtn.classList.toggle('is-saved', isSaved);
            stickyWishlistBtn.classList.toggle('is-active', isSaved);
          }
        } catch (err) {}
      };

      document.addEventListener('wishlist:update', syncAllWishlistStates);
      window.addEventListener('pageshow', () => {
        resetAllButtonLoadingStates();
        syncAllWishlistStates();
      });
      window.addEventListener('pagehide', () => {
        resetAllButtonLoadingStates();
      });
      syncAllWishlistStates();

      if (stickyBar) {
        // Sticky size buttons click handler
        stickySizes.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            const targetSize = btn.dataset.pfStickySize;
            const matchingPill = sizePills.find((p) => {
              const pillSize = (p.dataset.pfSizePill || p.textContent || '').trim().toLowerCase();
              return pillSize === targetSize.trim().toLowerCase();
            });
            if (matchingPill) {
              matchingPill.click();
            }
          });
        });

        // Sticky bar show/hide scroll controller for Mobile Responsive Only
        let stickyTicking = false;

        const updateStickyVisibility = () => {
          const isMobile = window.innerWidth <= 1024;
          if (!isMobile) {
            stickyBar.removeAttribute('data-visible');
            stickyBar.removeAttribute('data-mobile-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
            stickyTicking = false;
            return;
          }

          if (document.body.style.position === 'fixed') {
            stickyTicking = false;
            return;
          }

          const currentY = window.scrollY || window.pageYOffset || 0;
          const isNavHidden =
            document.body.getAttribute('data-mobile-nav-hidden') === 'true' ||
            document.getElementById('stagmenfashion-mobile-nav')?.getAttribute('data-hidden') === 'true';

          if (isNavHidden && currentY > 90) {
            stickyBar.setAttribute('data-mobile-visible', 'true');
            stickyBar.setAttribute('aria-hidden', 'false');
          } else {
            stickyBar.removeAttribute('data-mobile-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }

          stickyTicking = false;
        };

        window.addEventListener(
          'scroll',
          () => {
            if (!stickyTicking) {
              window.requestAnimationFrame(updateStickyVisibility);
              stickyTicking = true;
            }
          },
          { passive: true }
        );

        window.addEventListener('mobilenav:toggle', (e) => {
          if (window.innerWidth <= 1024) {
            if (e.detail?.hidden && window.scrollY > 90) {
              stickyBar.setAttribute('data-mobile-visible', 'true');
              stickyBar.setAttribute('aria-hidden', 'false');
            } else {
              stickyBar.removeAttribute('data-mobile-visible');
              stickyBar.setAttribute('aria-hidden', 'true');
            }
          }
        });

        window.addEventListener('resize', updateStickyVisibility, { passive: true });
        updateStickyVisibility();
      }

      // Pre-select color and size from URL query param
      const preselectSavedOptions = () => {
        const urlParams = new URLSearchParams(window.location.search);
        let targetVariantId = urlParams.get('variant');
        let targetColor = urlParams.get('color');
        let targetSize = urlParams.get('size');

        try {
          const currentHandle =
            root.dataset.productHandle ||
            window.location.pathname.split('/products/')[1]?.split('?')[0]?.replace(/\/$/, '');
          const list = JSON.parse(localStorage.getItem('wishlist') || '[]');
          const item = list.find((i) => i.handle === currentHandle);
          if (item) {
            if (!targetVariantId && item.variantId) targetVariantId = item.variantId;
            if (!targetColor && item.color) targetColor = item.color;
            if (!targetSize && item.size && item.size !== 'Default') targetSize = item.size;
          }
        } catch (err) {}

        if (targetVariantId && Array.isArray(variantData)) {
          const vMatch = variantData.find((v) => String(v.id) === String(targetVariantId));
          if (vMatch) {
            const vOpts = [vMatch.option1, vMatch.option2, vMatch.option3].filter(Boolean);
            if (!targetColor && swatches.length > 0) {
              const foundColorSwatch = swatches.find((s) => {
                const cName = (s.dataset.colorName || '').trim().toLowerCase();
                return vOpts.some((o) => String(o).trim().toLowerCase() === cName);
              });
              if (foundColorSwatch) {
                targetColor = foundColorSwatch.dataset.colorName;
              }
            }
            if (!targetSize && sizePills.length > 0) {
              const foundSizePill = sizePills.find((p) => {
                const pSize = (p.dataset.size || p.dataset.value || p.dataset.pfSizePill || p.textContent || '').trim().toLowerCase();
                return vOpts.some((o) => String(o).trim().toLowerCase() === pSize);
              });
              if (foundSizePill) {
                targetSize = (foundSizePill.dataset.size || foundSizePill.dataset.value || foundSizePill.dataset.pfSizePill || foundSizePill.textContent || '').trim();
              }
            }
          }
        }

        let hasChanged = false;

        if (targetColor && swatches.length > 0) {
          const cleanTargetColor = targetColor.trim().toLowerCase();
          const matchingSwatch = swatches.find((s) => {
            const swatchColor = (s.dataset.colorName || '').trim().toLowerCase();
            return swatchColor === cleanTargetColor;
          });

          if (matchingSwatch) {
            swatches.forEach((s) => {
              s.classList.remove('is-active');
              s.setAttribute('aria-pressed', 'false');
            });
            matchingSwatch.classList.add('is-active');
            matchingSwatch.setAttribute('aria-pressed', 'true');
            selectedColor = (matchingSwatch.dataset.colorName || targetColor).trim();
            hasChanged = true;
          }
        }

        if (targetSize && sizePills.length > 0) {
          const cleanTargetSize = targetSize.trim().toLowerCase();
          const matchingPill = sizePills.find((p) => {
            const pillSize = (p.dataset.size || p.dataset.value || p.dataset.pfSizePill || p.textContent || '').trim().toLowerCase();
            return pillSize === cleanTargetSize;
          });

          if (matchingPill) {
            sizePills.forEach((p) => {
              p.classList.remove('is-active');
              p.classList.remove('is-selected');
            });
            matchingPill.classList.add('is-active');
            matchingPill.classList.add('is-selected');
            selectedSize = (matchingPill.dataset.size || matchingPill.dataset.value || matchingPill.dataset.pfSizePill || matchingPill.textContent || '').trim();

            stickySizes.forEach((sb) => {
              const sVal = (sb.dataset.pfStickySize || sb.textContent || '').trim().toLowerCase();
              sb.classList.toggle('is-active', sVal === selectedSize.toLowerCase());
            });
            hasChanged = true;
          }
        }

        if (hasChanged || targetColor || targetSize || targetVariantId) {
          updateOptionStates(false);
        }
      };

      preselectSavedOptions();
    }

    function initAll() {
      document.querySelectorAll('[data-pf-product]').forEach((el) => {
        initStagProductTemplate(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    window.addEventListener('pageshow', () => {
      document.querySelectorAll('.pf-btn.is-loading, .pf-sticky-btn.is-loading').forEach((b) => {
        b.classList.remove('is-loading');
        b.removeAttribute('aria-busy');
        b.disabled = false;
        if (b.dataset.loadingRestoreHtml) {
          b.innerHTML = b.dataset.loadingRestoreHtml;
          delete b.dataset.loadingRestoreHtml;
        }
      });
    });

    document.addEventListener('shopify:section:load', (e) => {
      if (e.target) {
        const productRoot = e.target.matches?.('[data-pf-product]') ? e.target : e.target.querySelector?.('[data-pf-product]');
        if (productRoot) initStagProductTemplate(productRoot);
        else initAll();
      }
    });

    // Delegated Global Fallback Handlers
    document.addEventListener('click', (e) => {
      const addBtn = e.target.closest('[data-pf-add-to-bag], [data-pf-sticky-add]');
      if (addBtn && !addBtn.disabled && !addBtn.classList.contains('is-loading')) {
        const root = addBtn.closest('[data-pf-product]') || document.querySelector('[data-pf-product]');
        if (root && !root._pfInitialized) {
          initStagProductTemplate(root);
          addBtn.click();
        }
      }

      const buyBtn = e.target.closest('[data-pf-buy-now], [data-pf-sticky-buy]');
      if (buyBtn && !buyBtn.disabled && !buyBtn.classList.contains('is-loading')) {
        const root = buyBtn.closest('[data-pf-product]') || document.querySelector('[data-pf-product]');
        if (root && !root._pfInitialized) {
          initStagProductTemplate(root);
          buyBtn.click();
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stagmenfashion-custom-gift-combo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents, locale, currency) => {
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          maximumFractionDigits: 2,
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return (currency === 'INR' ? '₹' : '$') + ((Number(cents) || 0) / 100).toFixed(2);
      }
    };

    const showToast = (section, message) => {
      let toast = section.querySelector('[data-gift-toast]');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'stagmenfashion-gift-combo__toast';
        toast.dataset.giftToast = 'true';
        section.appendChild(toast);
      }

      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toast._hideTimer);
      toast._hideTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 2400);
    };

    const escapeHtml = (value) =>
      String(value ?? '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character]));

    const syncHeaderCartCount = (itemCount) => {
      const count = Number(itemCount) || 0;
      const cartTrigger =
        document.querySelector('[data-testid="cart-drawer-trigger"]') ||
        document.querySelector('.stagmenfashion-header__right a[href*="/cart"]') ||
        document.querySelector('.stagmenfashion-mobile-tabs a[href*="/cart"]');

      if (!cartTrigger) return;

      const countNode =
        cartTrigger.querySelector('.stagmenfashion-header__cart-count') ||
        cartTrigger.querySelector('.stagmenfashion-mobile-tabs__badge');

      if (countNode) countNode.textContent = String(count);
    };

    const openCartDrawer = () => {
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
        return;
      }

      const cartLink = document.querySelector('.stagmenfashion-mobile-tabs a[href*="/cart"]');
      if (cartLink) {
        window.location.href = cartLink.href;
      }
    };

    const setupLoopCarousel = (carousel) => {
      if (!(carousel instanceof HTMLElement) || carousel.dataset.loopReady === 'true') return;
      const originals = Array.from(carousel.children).filter(
        (child) => child instanceof HTMLElement && child.hasAttribute('data-gift-card')
      );

      if (originals.length < 3) return;

      carousel.dataset.loopReady = 'true';

      const cloneCards = (cards) =>
        cards.map((card) => {
          const clone = card.cloneNode(true);
          if (clone instanceof HTMLElement) {
            clone.removeAttribute('data-gift-card');
            clone.dataset.giftCardClone = 'true';
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('tabindex', '-1');
            clone.setAttribute('role', 'presentation');
          }
          return clone;
        });

      const prepend = document.createDocumentFragment();
      const append = document.createDocumentFragment();

      cloneCards(originals).reverse().forEach((clone) => prepend.appendChild(clone));
      cloneCards(originals).forEach((clone) => append.appendChild(clone));

      carousel.prepend(prepend);
      carousel.append(append);

      const measureLoopWidth = () => {
        const cardWidth = originals[0].getBoundingClientRect().width;
        const styles = getComputedStyle(carousel);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return (cardWidth + gap) * originals.length;
      };

      const resetToMiddle = () => {
        const width = measureLoopWidth();
        carousel.scrollLeft = width;
      };

      requestAnimationFrame(resetToMiddle);

      let rafId = 0;
      const normalizeScroll = () => {
        window.cancelAnimationFrame(rafId);
        rafId = window.requestAnimationFrame(() => {
          const width = measureLoopWidth();
          const total = carousel.scrollWidth;
          const leftEdge = width * 0.45;
          const rightEdge = total - carousel.clientWidth - width * 0.45;

          if (carousel.scrollLeft <= leftEdge) {
            carousel.scrollLeft += width;
          } else if (carousel.scrollLeft >= rightEdge) {
            carousel.scrollLeft -= width;
          }
        });
      };

      carousel.addEventListener('scroll', normalizeScroll, { passive: true });
      window.addEventListener('resize', resetToMiddle, { passive: true });
    };

    const initGiftCombo = (section) => {
      if (!section || section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';

      const tabs = Array.from(section.querySelectorAll('[data-gift-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-gift-panel]'));
      const cards = Array.from(section.querySelectorAll('.stagmenfashion-gift-combo__carousel > [data-gift-card]'));
      const selectedIds = [];

      const locale = section.dataset.locale || document.documentElement.lang || navigator.language || 'en-IN';
      const currency = section.dataset.currency || 'INR';
      const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';
      const discountThreshold = Number(section.dataset.discountThreshold || 99900);
      const discountPercent = Number(section.dataset.discountPercent || 5);

      const summaryList = section.querySelector('[data-gift-summary-list]');
      const subtotalNode = section.querySelector('[data-gift-subtotal]');
      const savingsNode = section.querySelector('[data-gift-savings]');
      const totalNode = section.querySelector('[data-gift-total]');
      const discountRow = section.querySelector('[data-gift-discount-row]');
      const progressFill = section.querySelector('[data-gift-progress]');
      const progressCopy = section.querySelector('[data-gift-progress-copy]');
      const countNode = section.querySelector('[data-gift-count]');
      const addButton = section.querySelector('[data-gift-add]');
      const addLabel = section.querySelector('[data-gift-add-label]');
      const resetButton = section.querySelector('[data-gift-reset]');

      const cardsById = new Map(cards.map((card) => [card.dataset.giftId, card]));
      const carousel = section.querySelector('[data-gift-carousel]');
      if (carousel) {
        setupLoopCarousel(carousel);
      }

      const selectedCards = () => selectedIds.map((id) => cardsById.get(id)).filter(Boolean);

      const updateCardState = () => {
        cards.forEach((card) => {
          const isSelected = selectedIds.includes(card.dataset.giftId);
          card.classList.toggle('is-selected', isSelected);
          card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      };

      const renderSummary = () => {
        const items = selectedCards();
        const subtotal = items.reduce((sum, card) => sum + Number(card.dataset.price || 0), 0);
        const thresholdReached = subtotal >= discountThreshold;
        const savings = thresholdReached ? Math.round((subtotal * discountPercent) / 100) : 0;
        const total = subtotal - savings;
        const progress = discountThreshold > 0 ? Math.min((subtotal / discountThreshold) * 100, 100) : 0;

        if (countNode) countNode.textContent = `${items.length} selected`;
        if (subtotalNode) subtotalNode.textContent = formatMoney(subtotal, locale, currency);
        if (savingsNode) savingsNode.textContent = formatMoney(savings, locale, currency);
        if (totalNode) totalNode.textContent = formatMoney(total, locale, currency);
        if (progressFill) progressFill.style.width = `${progress}%`;
        if (discountRow) discountRow.hidden = !thresholdReached || savings <= 0;

        if (progressCopy) {
          if (!items.length) {
            progressCopy.textContent = 'Start selecting products';
          } else if (thresholdReached) {
            progressCopy.textContent = `${discountPercent}% savings unlocked`;
          } else {
            const remaining = Math.max(discountThreshold - subtotal, 0);
            progressCopy.textContent = `${formatMoney(remaining, locale, currency)} left to unlock ${discountPercent}% off`;
          }
        }

        if (summaryList) {
          if (!items.length) {
            summaryList.innerHTML =
              '<p class="stagmenfashion-gift-combo__empty">Choose products from one or more occasion tabs. The combo stays in sync as you add or remove items.</p>';
          } else {
              summaryList.innerHTML = items
              .map((card) => {
                const title = card.dataset.title || 'Product';
                const price = card.dataset.price || 0;
                return `
                  <p class="stagmenfashion-gift-combo__summary-item" data-selected-item="${card.dataset.giftId}">
                    <span>
                      ${escapeHtml(title)}
                      <small>${escapeHtml(card.dataset.collection || '')}</small>
                    </span>
                    <strong>
                      ${formatMoney(price, locale, currency)}
                      <button type="button" data-remove-gift-id="${card.dataset.giftId}" aria-label="Remove ${escapeHtml(title)}">Remove</button>
                    </strong>
                  </p>
                `;
              })
              .join('');
          }
        }

        if (addButton) {
          addButton.disabled = items.length === 0;
        }
        if (addLabel) {
          if (!items.length) {
            addLabel.textContent = 'Pick items to continue';
          } else {
          addLabel.textContent = thresholdReached ? 'Add combo with savings' : 'Add room combo';
          }
        }

        updateCardState();
      };

      const activatePanel = (targetId) => {
        tabs.forEach((tab) => {
          const isActive = tab.dataset.target === targetId;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const isActive = panel.id === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      };

      const addCard = (card) => {
        if (card.dataset.available === 'false') {
          showToast(section, 'This product is sold out.');
          return;
        }

        if (selectedIds.includes(card.dataset.giftId)) return;

        selectedIds.push(card.dataset.giftId);
        renderSummary();
      };

      const removeCard = (giftId) => {
        const index = selectedIds.indexOf(giftId);
        if (index === -1) return;
        selectedIds.splice(index, 1);
        renderSummary();
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activatePanel(tab.dataset.target));
      });

      section.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-remove-gift-id]');
        if (removeButton) {
          event.preventDefault();
          removeCard(removeButton.dataset.removeGiftId);
          return;
        }

        const toggleButton = event.target.closest('[data-gift-card-toggle]');
        if (toggleButton) {
          const card = toggleButton.closest('[data-gift-card]');
          if (!card) return;
          event.preventDefault();
          if (selectedIds.includes(card.dataset.giftId)) {
            removeCard(card.dataset.giftId);
          } else {
            addCard(card);
          }
          return;
        }

        const card = event.target.closest('[data-gift-card]');
        if (!card) return;

        event.preventDefault();
        if (selectedIds.includes(card.dataset.giftId)) {
          removeCard(card.dataset.giftId);
        } else {
          addCard(card);
        }
      });

      section.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const card = event.target.closest('[data-gift-card]');
        if (!card) return;
        event.preventDefault();
        if (selectedIds.includes(card.dataset.giftId)) {
          removeCard(card.dataset.giftId);
        } else {
          addCard(card);
        }
      });

      addButton?.addEventListener('click', async () => {
        const items = selectedCards().map((card) => ({
          id: Number(card.dataset.variantId),
          quantity: 1,
        }));

        addButton.disabled = true;
        addButton.dataset.loading = 'true';

        try {
          const response = await fetch(`${cartAddUrl}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });

          const cart = await response.json();
          if (!response.ok || cart?.status) {
            throw new Error(cart?.description || cart?.message || 'Add to cart failed');
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                data: {
                  source: 'stagmenfashion-gift-combo',
                  itemCount: cart.item_count,
                },
              },
            })
          );

          syncHeaderCartCount(cart.item_count);
          showToast(section, 'Your room combo was added to cart.');
          openCartDrawer();
        } catch (error) {
          console.error(error);
          showToast(section, 'We could not add the combo. Please try again.');
        } finally {
          addButton.disabled = selectedIds.length === 0;
          addButton.dataset.loading = 'false';
          renderSummary();
        }
      });

      resetButton?.addEventListener('click', () => {
        selectedIds.length = 0;
        renderSummary();
      });

      const initialTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
      if (initialTab?.dataset.target) {
        activatePanel(initialTab.dataset.target);
      }

      renderSummary();
    };

    const initAll = (root = document) => {
      root.querySelectorAll('[data-stagmenfashion-gift-combo]').forEach(initGiftCombo);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stagmenfashion-minimal-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initHero = () => {
      document.querySelectorAll('[data-stagmenfashion-min-hero]').forEach((hero) => {
        if (hero.dataset.initialized === 'true') return;
        hero.dataset.initialized = 'true';

        const track = hero.querySelector('[data-track]');
        const slides = Array.from(hero.querySelectorAll('[data-slide]'));
        const total = slides.length;
        if (total <= 1) return;

        const counterCurrent = hero.querySelector('[data-counter-current]');
        const progressFill = hero.querySelector('[data-progress-fill]');
        const prevBtn = hero.querySelector('[data-action="prev"]');
        const nextBtn = hero.querySelector('[data-action="next"]');
        const autoplayMs = parseInt(hero.dataset.autoplay, 10) || 0;

        let currentIndex = 0;
        let autoplayTimer = null;
        let progressTimer = null;
        let progressStart = 0;

        const updatePagination = (idx) => {
          if (counterCurrent) {
            counterCurrent.textContent = (idx + 1 < 10 ? '0' : '') + (idx + 1);
          }
        };

        const resetProgress = () => {
          if (progressTimer) cancelAnimationFrame(progressTimer);
          if (progressFill) progressFill.style.width = '0%';
        };

        const startProgress = () => {
          if (!autoplayMs || !progressFill) return;
          resetProgress();
          progressStart = performance.now();

          const frame = (now) => {
            const elapsed = now - progressStart;
            const pct = Math.min(100, (elapsed / autoplayMs) * 100);
            progressFill.style.width = pct + '%';
            if (pct < 100) {
              progressTimer = requestAnimationFrame(frame);
            }
          };
          progressTimer = requestAnimationFrame(frame);
        };

        const goToSlide = (newIndex) => {
          currentIndex = (newIndex + total) % total;
          track.style.transform = `translateX(-${currentIndex * 100}%)`;

          slides.forEach((s, idx) => {
            if (idx === currentIndex) {
              s.classList.add('is-active');
              s.setAttribute('aria-hidden', 'false');
            } else {
              s.classList.remove('is-active');
              s.setAttribute('aria-hidden', 'true');
            }
          });

          updatePagination(currentIndex);
          startAutoplay();
        };

        const startAutoplay = () => {
          if (autoplayTimer) clearInterval(autoplayTimer);
          if (autoplayMs > 0) {
            startProgress();
            autoplayTimer = setInterval(() => {
              goToSlide(currentIndex + 1);
            }, autoplayMs);
          }
        };

        const stopAutoplay = () => {
          if (autoplayTimer) clearInterval(autoplayTimer);
          resetProgress();
        };

        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            goToSlide(currentIndex - 1);
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            goToSlide(currentIndex + 1);
          });
        }

        hero.addEventListener('mouseenter', stopAutoplay);
        hero.addEventListener('mouseleave', startAutoplay);

        // Touch swipe support with vertical scroll preservation
        let startX = 0;
        let startY = 0;
        let currentX = 0;
        let currentY = 0;
        let isTouching = false;

        hero.addEventListener('touchstart', (e) => {
          if (!e.touches || !e.touches[0]) return;
          isTouching = true;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          currentX = startX;
          currentY = startY;
          stopAutoplay();
        }, { passive: true });

        hero.addEventListener('touchmove', (e) => {
          if (!isTouching || !e.touches || !e.touches[0]) return;
          currentX = e.touches[0].clientX;
          currentY = e.touches[0].clientY;
        }, { passive: true });

        hero.addEventListener('touchend', () => {
          if (!isTouching) return;
          isTouching = false;
          const diffX = startX - currentX;
          const diffY = startY - currentY;
          if (total > 1 && Math.abs(diffX) > 50 && Math.abs(diffX) > Math.abs(diffY) * 1.4) {
            if (diffX > 0) {
              goToSlide(currentIndex + 1);
            } else {
              goToSlide(currentIndex - 1);
            }
          } else {
            startAutoplay();
          }
        });

        // Initialize first state
        updatePagination(0);
        startAutoplay();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHero);
    } else {
      initHero();
    }

    document.addEventListener('shopify:section:load', initHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stagmenfashion-premium-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const header = document.querySelector('.stagmenfashion-header--hero-overlay');
    let lastScrollY = window.scrollY;

    const applyHeroHeaderState = () => {
      if (!header) return;

      if (header.classList.contains('stagmenfashion-header--about-page')) {
        header.dataset.scrollDirection = 'none';
        header.dataset.scrolled = 'false';
        header.dataset.stickyState = 'inactive';
        return;
      }

      // Read real scroll position (accounting for fixed body lock during open drawers/modals)
      const currentScrollY = document.body.style.position === 'fixed'
        ? Math.abs(parseInt(document.body.style.top || '0', 10))
        : window.scrollY;

      const isAtTop = currentScrollY <= 12;
      const isScrollingUp = currentScrollY < lastScrollY;
      const isScrollingDown = currentScrollY > lastScrollY;

      header.dataset.scrollDirection = isAtTop ? 'none' : isScrollingUp ? 'up' : isScrollingDown ? 'down' : header.dataset.scrollDirection || 'none';

      if (isAtTop) {
        header.dataset.scrolled = 'false';
        header.dataset.stickyState = 'inactive';
      } else if (isScrollingUp) {
        header.dataset.scrolled = 'true';
        header.dataset.stickyState = 'active';
      } else if (isScrollingDown) {
        header.dataset.scrolled = 'false';
        header.dataset.stickyState = 'inactive';
      }

      lastScrollY = currentScrollY;
    };

    const updateCartCount = (itemCount) => {
      const cartButtons = document.querySelectorAll('.stagmenfashion-header__cart-button, .stagmenfashion-mobile-tabs__item[href*="/cart"], .stagmenfashion-mobile-tabs__item[aria-label="Cart"]');
      
      cartButtons.forEach((cartBtn) => {
        let countNode = cartBtn.querySelector('.stagmenfashion-header__cart-count, .stagmenfashion-mobile-tabs__badge');
        
        if (!countNode) {
          countNode = document.createElement('span');
          if (cartBtn.classList.contains('stagmenfashion-mobile-tabs__item')) {
            countNode.className = 'stagmenfashion-mobile-tabs__badge';
            const iconWrapper = cartBtn.querySelector('.stagmenfashion-mobile-tabs__icon');
            if (iconWrapper) {
              iconWrapper.appendChild(countNode);
            } else {
              cartBtn.appendChild(countNode);
            }
          } else {
            countNode.className = 'stagmenfashion-header__cart-count';
            cartBtn.appendChild(countNode);
          }
        }

        if (itemCount > 0) {
          countNode.textContent = String(itemCount);
          countNode.style.display = '';
          countNode.hidden = false;
          countNode.removeAttribute('aria-hidden');
        } else {
          countNode.textContent = '0';
          countNode.style.display = 'none';
          countNode.hidden = true;
          countNode.setAttribute('aria-hidden', 'true');
        }
      });
    };

    const readSessionCount = () => {
      try {
        const raw = sessionStorage.getItem('cart-count');
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const value = Number(parsed?.value);
        return Number.isFinite(value) ? value : null;
      } catch (error) {
        return null;
      }
    };

    const syncFromServer = async () => {
      try {
        const response = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) return;
        const cart = await response.json();
        updateCartCount(Number(cart?.item_count) || 0);
      } catch (error) {
        // Ignore network failures; the session/event-based sync will still work.
      }
    };

    document.addEventListener('cart:update', (event) => {
      const itemCount = Number(event.detail?.data?.itemCount ?? event.detail?.resource?.item_count ?? 0);
      updateCartCount(itemCount);
    });

    window.addEventListener('cart:update', (event) => {
      const itemCount = Number(event.detail?.data?.itemCount ?? event.detail?.resource?.item_count ?? 0);
      updateCartCount(itemCount);
    });

    const initialCount = readSessionCount();
    if (initialCount !== null) {
      updateCartCount(initialCount);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncFromServer, { once: true });
    } else {
      syncFromServer();
    }

    const openMobileMenu = () => {
      const drawer = document.querySelector('header-drawer.header-drawer');
      const details = drawer?.querySelector('details.menu-drawer-container');

      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }

      if (details) {
        details.open = true;
        details.setAttribute('open', '');
        details.classList.add('menu-open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      }
    };

    const openCartDrawer = () => {
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
        return;
      }

      window.location.href = document.querySelector('.stagmenfashion-mobile-tabs a[href*="/cart"]')?.href || '/cart';
    };

    document.querySelectorAll('[data-open-mobile-menu]').forEach((button) => {
      button.addEventListener('click', openMobileMenu);
    });

    document.querySelectorAll('[data-open-cart-drawer]').forEach((button) => {
      button.addEventListener('click', openCartDrawer);
    });

    document.querySelectorAll('[data-cart-drawer-recommendations]').forEach((drawer) => {
      const track = drawer.querySelector('.cart-drawer__recommendations-track');
      const prev = drawer.querySelector('[data-cart-drawer-recommendations-prev]');
      const next = drawer.querySelector('[data-cart-drawer-recommendations-next]');
      const slides = Array.from(drawer.querySelectorAll('[data-cart-drawer-recommendation-slide]'));
      const dots = Array.from(drawer.querySelectorAll('[data-cart-drawer-recommendation-dot]'));

      if (!track || slides.length === 0) return;

      const getStep = () => {
        const slide = slides[0];
        const slideWidth = slide.getBoundingClientRect().width;
        const gap = parseFloat(window.getComputedStyle(track).gap || '0') || 0;
        return slideWidth + gap;
      };

      const setActiveDot = (index) => {
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const setArrowState = () => {
        const atStart = track.scrollLeft <= 2;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      };

      const getActiveIndex = () => {
        const viewportCenter = track.scrollLeft + track.clientWidth / 2;
        let activeIndex = 0;
        let activeDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(slideCenter - viewportCenter);
          if (distance < activeDistance) {
            activeDistance = distance;
            activeIndex = index;
          }
        });

        return activeIndex;
      };

      const updateActiveState = () => {
        setActiveDot(getActiveIndex());
        setArrowState();
      };

      prev?.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next?.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number(dot.dataset.cartDrawerRecommendationDot || 0);
          const slide = slides[index];
          if (!slide) return;
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', () => {
        window.requestAnimationFrame(updateActiveState);
      }, { passive: true });

      window.addEventListener('resize', updateActiveState, { passive: true });
      updateActiveState();
    });

    if (header) {
      applyHeroHeaderState();
      window.addEventListener('scroll', applyHeroHeaderState, { passive: true });
      window.addEventListener('resize', applyHeroHeaderState, { passive: true });
      document.addEventListener('cart:update', applyHeroHeaderState);
      document.addEventListener('wishlist:update', applyHeroHeaderState);
      document.addEventListener('wishlist-drawer:open', applyHeroHeaderState);
      document.addEventListener('wishlist-drawer:close', () => setTimeout(applyHeroHeaderState, 220));
      window.addEventListener('dialog:open', applyHeroHeaderState);
      window.addEventListener('dialog:close', () => setTimeout(applyHeroHeaderState, 220));

      const bodyObserver = new MutationObserver(() => {
        applyHeroHeaderState();
      });
      bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stagmenfashion-premium-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-stagmenfashion-hero]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const track = root.querySelector('[data-track]');
      const slides = Array.from(root.querySelectorAll('[data-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-dot]'));
      const prevBtn = root.querySelector('[data-action="prev"]');
      const nextBtn = root.querySelector('[data-action="next"]');
      const autoplay = Number(root.dataset.autoplay) || 0;
      let index = 0;
      let timer = null;
      let pointerId = null;
      let dragStartX = 0;
      let dragDeltaX = 0;
      let isDragging = false;

      if (!track || slides.length === 0) return;

      const autoplayMs = autoplay > 0 ? autoplay : 6000;

      root.style.setProperty('--stagmenfashion-autoplay', autoplayMs + 'ms');

      const activate = (nextIndex) => {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = `translateX(-${index * 100}%)`;

        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });

        dots.forEach((dot, i) => {
          const active = i === index;
          if (active) {
            dot.classList.remove('is-active');
            void dot.offsetWidth;
            dot.classList.add('is-active');
          } else {
            dot.classList.remove('is-active');
          }
          dot.setAttribute('aria-selected', String(active));
        });
      };

      if (slides.length > 1) {
        prevBtn?.addEventListener('click', () => activate(index - 1));
        nextBtn?.addEventListener('click', () => activate(index + 1));
        dots.forEach((dot) => {
          dot.addEventListener('click', () => activate(Number(dot.dataset.dot)));
        });

        const startAutoplay = () => {
          if (autoplay > 0) {
            timer = setInterval(() => activate(index + 1), autoplay);
          }
        };

        const stopAutoplay = () => {
          if (timer) { clearInterval(timer); timer = null; }
        };

        root.addEventListener('mouseenter', stopAutoplay);
        root.addEventListener('mouseleave', startAutoplay);

        root.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          pointerId = e.pointerId;
          dragStartX = e.clientX;
          dragDeltaX = 0;
          isDragging = true;
          stopAutoplay();
          track.style.transition = 'none';
        });

        root.addEventListener('pointermove', (e) => {
          if (!isDragging || e.pointerId !== pointerId) return;
          dragDeltaX = e.clientX - dragStartX;
          const offset = -index * 100 + (dragDeltaX / root.offsetWidth) * 100;
          track.style.transform = `translateX(${offset}%)`;
        });

        const endDrag = () => {
          if (!isDragging) return;
          isDragging = false;
          pointerId = null;
          track.style.transition = '';
          if (dragDeltaX < -25) activate(index + 1);
          else if (dragDeltaX > 25) activate(index - 1);
          else activate(index);
          dragDeltaX = 0;
          startAutoplay();
        };

        root.addEventListener('pointerup', endDrag);
        root.addEventListener('pointercancel', endDrag);
        window.addEventListener('resize', () => activate(index));

        activate(index);
        startAutoplay();
      } else {
        activate(0);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stagmenfashion-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initDrawerSpotlight = (scope = document) => {
      scope.querySelectorAll('[data-stagmenfashion-spotlight]').forEach((section) => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';

        const panels = Array.from(section.querySelectorAll('[data-spotlight-panel]'));
        const seeAllBottom = section.querySelector('[data-spotlight-see-all-bottom]');
        const prevBtn = section.querySelector('[data-spotlight-nav="prev"]');
        const nextBtn = section.querySelector('[data-spotlight-nav="next"]');
        const bottomRowEl = section.querySelector('[data-spotlight-bottom-nav-row]');
        const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';
        const noResults = section.querySelector('[data-spotlight-no-results]');
        const activeFiltersEl = section.querySelector('[data-spotlight-active-filters]');
        const activeTagEl = section.querySelector('[data-spotlight-active-tag]');
        const resultsCountEl = section.querySelector('[data-spotlight-results-count]');

        // Drawer elements
        const drawer = section.querySelector('[data-spotlight-drawer]');
        const drawerOverlay = section.querySelector('[data-spotlight-drawer-overlay]');
        const drawerTrigger = section.querySelector('[data-spotlight-drawer-trigger]');
        const drawerCloseBtns = Array.from(section.querySelectorAll('[data-spotlight-drawer-close]'));
        const filterBadge = section.querySelector('[data-spotlight-filter-badge]');

        // ---- State ----
        let activeCollectionPanelId = null;
        let activeCategory = 'all';
        let activeSubcategory = 'all';
        let activePrice = 'all';
        let activeSort = 'best-selling';

        // ---- Drawer Actions ----
        const openDrawer = () => {
          if (!drawer) return;
          drawer.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden'; // prevent scrolling underneath
        };

        const closeDrawer = () => {
          if (!drawer) return;
          drawer.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        };

        if (drawerTrigger) {
          drawerTrigger.addEventListener('click', openDrawer);
        }

        if (drawerOverlay) {
          drawerOverlay.addEventListener('click', closeDrawer);
        }

        drawerCloseBtns.forEach((btn) => btn.addEventListener('click', closeDrawer));

        // ESC key to close
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') {
            closeDrawer();
          }
        });

        // ---- Collection switching ----
        const activateCollection = (targetId) => {
          activeCollectionPanelId = targetId;

          // Toggle drawer option UI
          section.querySelectorAll('[data-spotlight-collection-tab-ref]').forEach((btn) => {
            const isActive = btn.dataset.spotlightCollectionTabRef === targetId;
            btn.classList.toggle('is-active', isActive);
          });

          // Toggle panel views
          panels.forEach((panel) => {
            const isActive = panel.id === targetId;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;

            if (isActive && seeAllBottom && panel.dataset.spotlightUrl) {
              seeAllBottom.href = panel.dataset.spotlightUrl;
            }
          });

          applyFilters();
        };

        section.querySelectorAll('[data-spotlight-collection-filters]').forEach((group) => {
          group.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-spotlight-collection-tab-ref]');
            if (!btn) return;
            activateCollection(btn.dataset.spotlightCollectionTabRef);
          });
        });

        // ---- Category filter ----
        section.querySelectorAll('[data-spotlight-category-filters]').forEach((group) => {
          group.addEventListener('click', (e) => {
            const item = e.target.closest('[data-spotlight-category]');
            if (!item) return;
            group.querySelectorAll('[data-spotlight-category]').forEach((c) => c.classList.remove('is-active'));
            item.classList.add('is-active');
            activeCategory = item.dataset.spotlightCategory;
            applyFilters();
          });
        });

        // ---- Sub-category filter ----
        section.querySelectorAll('[data-spotlight-subcategory-filters]').forEach((group) => {
          group.addEventListener('click', (e) => {
            const item = e.target.closest('[data-spotlight-subcategory]');
            if (!item) return;
            group.querySelectorAll('[data-spotlight-subcategory]').forEach((c) => c.classList.remove('is-active'));
            item.classList.add('is-active');
            activeSubcategory = item.dataset.spotlightSubcategory;
            applyFilters();
          });
        });

        // ---- Price filter ----
        section.querySelectorAll('[data-spotlight-price-filters]').forEach((group) => {
          group.addEventListener('click', (e) => {
            const item = e.target.closest('[data-spotlight-price]');
            if (!item) return;
            group.querySelectorAll('[data-spotlight-price]').forEach((c) => c.classList.remove('is-active'));
            item.classList.add('is-active');
            activePrice = item.dataset.spotlightPrice;
            applyFilters();
          });
        });

        // ---- Sort options ----
        section.querySelectorAll('[data-spotlight-sort-options]').forEach((group) => {
          group.addEventListener('click', (e) => {
            const item = e.target.closest('[data-spotlight-sort-val]');
            if (!item) return;
            group.querySelectorAll('[data-spotlight-sort-val]').forEach((c) => c.classList.remove('is-active'));
            item.classList.add('is-active');
            activeSort = item.dataset.spotlightSortVal;
            applyFilters();
          });
        });

        // ---- Clear filters ----
        const clearFilters = () => {
          activeCategory = 'all';
          activeSubcategory = 'all';
          activePrice = 'all';
          activeSort = 'best-selling';

          section.querySelectorAll('[data-spotlight-category]').forEach((c) => {
            c.classList.toggle('is-active', c.dataset.spotlightCategory === 'all');
          });
          section.querySelectorAll('[data-spotlight-subcategory]').forEach((c) => {
            c.classList.toggle('is-active', c.dataset.spotlightSubcategory === 'all');
          });
          section.querySelectorAll('[data-spotlight-price]').forEach((c) => {
            c.classList.toggle('is-active', c.dataset.spotlightPrice === 'all');
          });
          section.querySelectorAll('[data-spotlight-sort-val]').forEach((c) => {
            c.classList.toggle('is-active', c.dataset.spotlightSortVal === 'best-selling');
          });

          applyFilters();
        };

        const clearBtn = section.querySelector('[data-spotlight-clear-filters]');
        if (clearBtn) {
          clearBtn.addEventListener('click', clearFilters);
        }

        // ---- Filtering + Sorting ----
        const applyFilters = () => {
          const currentPanel = panels.find((p) => p.id === activeCollectionPanelId);
          if (!currentPanel) return;

          const carousel = currentPanel.querySelector('.stagmenfashion-spotlight__carousel');
          if (!carousel) return;

          const cards = Array.from(carousel.querySelectorAll('.stagmenfashion-spotlight-card'));
          let visibleCount = 0;

          cards.forEach((card) => {
            const cardType = (card.dataset.productType || '').toLowerCase();
            const cardPrice = parseInt(card.dataset.productPrice || '0', 10) / 100;
            const cardTags = (card.dataset.productTags || '').split(',');

            let showByCategory = activeCategory === 'all' || cardType === activeCategory;
            let showBySubcategory = activeSubcategory === 'all' || cardTags.includes(activeSubcategory);
            let showByPrice = true;

            if (activePrice !== 'all') {
              const parts = activePrice.split('-');
              const min = parseInt(parts[0], 10);
              const max = parseInt(parts[1], 10);
              showByPrice = cardPrice >= min && cardPrice <= max;
            }

            const visible = showByCategory && showBySubcategory && showByPrice;
            card.dataset.filtered = visible ? 'false' : 'true';
            if (visible) visibleCount++;
          });

          // Sort visible cards
          const visibleCards = cards.filter((c) => c.dataset.filtered !== 'true');
          const priceAsc = (a, b) => parseInt(a.dataset.productPrice || '0') - parseInt(b.dataset.productPrice || '0');
          const priceDesc = (a, b) => parseInt(b.dataset.productPrice || '0') - parseInt(a.dataset.productPrice || '0');
          const titleAsc = (a, b) => (a.dataset.productTitle || '').localeCompare(b.dataset.productTitle || '');
          const titleDesc = (a, b) => (b.dataset.productTitle || '').localeCompare(a.dataset.productTitle || '');

          const sortMap = {
            'best-selling': null,
            'price-ascending': priceAsc,
            'price-descending': priceDesc,
            'title-ascending': titleAsc,
            'title-descending': titleDesc,
          };

          const sortFn = sortMap[activeSort];
          if (sortFn) {
            visibleCards.sort(sortFn);
            visibleCards.forEach((card) => carousel.appendChild(card));
          }

          // Update active filters badge count
          let activeCount = 0;
          if (activeCategory !== 'all') activeCount++;
          if (activeSubcategory !== 'all') activeCount++;
          if (activePrice !== 'all') activeCount++;
          if (activeSort !== 'best-selling') activeCount++;
          if (filterBadge) {
            filterBadge.textContent = activeCount;
            filterBadge.style.display = activeCount > 0 ? 'inline-flex' : 'none';
          }

          // Update active filter tags banner on homepage
          if (activeFiltersEl) {
            const tags = [];
            if (activeCategory !== 'all') {
              const catItem = section.querySelector(`[data-spotlight-category="${activeCategory}"]`);
              tags.push(catItem?.dataset.spotlightCategoryLabel || activeCategory);
            }
            if (activeSubcategory !== 'all') {
              const subItem = section.querySelector(`[data-spotlight-subcategory="${activeSubcategory}"]`);
              tags.push(subItem?.dataset.spotlightSubcategoryLabel || activeSubcategory);
            }
            if (activePrice !== 'all') {
              const priceItem = section.querySelector(`[data-spotlight-price="${activePrice}"]`);
              tags.push(priceItem?.dataset.spotlightPriceLabel || activePrice);
            }

            if (tags.length > 0) {
              activeFiltersEl.style.display = 'flex';
              activeTagEl.textContent = tags.join(' · ');
            } else {
              activeFiltersEl.style.display = 'none';
            }
          }

          // Results count
          if (resultsCountEl) {
            resultsCountEl.textContent = `${visibleCount} product${visibleCount !== 1 ? 's' : ''} found`;
          }

          // No results
          if (noResults) {
            noResults.style.display = visibleCount === 0 ? 'block' : 'none';
          }

          // Hide bottom row if no results matching filters
          if (bottomRowEl) {
            bottomRowEl.style.display = visibleCount === 0 ? 'none' : 'flex';
          }
        };

        // ---- Add to Cart ----
        section.querySelectorAll('[data-stagmenfashion-spotlight-add]').forEach((button) => {
          button.addEventListener('click', async (event) => {
            event.preventDefault();
            const form = button.closest('form');
            const variantId = form?.querySelector('input[name="id"]')?.value;
            if (!variantId) return;

            button.disabled = true;
            button.dataset.loading = 'true';

            try {
              const response = await fetch(`${cartAddUrl}.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
              });

              const cart = await response.json();
              if (!response.ok || cart?.status) {
                throw new Error(cart?.description || cart?.message || 'Add to cart failed');
              }

              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    data: { source: 'stagmenfashion-spotlight', itemCount: cart.item_count },
                  },
                })
              );

              document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
            } catch (error) {
              console.error(error);
            } finally {
              button.disabled = false;
              button.dataset.loading = 'false';
            }
          });
        });

        // ---- Navigation Scrolling ----
        const getActiveCarousel = () => {
          const currentPanel = panels.find((p) => p.id === activeCollectionPanelId);
          return currentPanel?.querySelector('.stagmenfashion-spotlight__carousel');
        };

        if (prevBtn) {
          prevBtn.addEventListener('click', () => {
            const carousel = getActiveCarousel();
            if (carousel) {
              const card = carousel.querySelector('.stagmenfashion-spotlight-card');
              const scrollVal = card ? card.offsetWidth + 20 : 320;
              carousel.scrollBy({ left: -scrollVal, behavior: 'smooth' });
            }
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener('click', () => {
            const carousel = getActiveCarousel();
            if (carousel) {
              const card = carousel.querySelector('.stagmenfashion-spotlight-card');
              const scrollVal = card ? card.offsetWidth + 20 : 320;
              carousel.scrollBy({ left: scrollVal, behavior: 'smooth' });
            }
          });
        }

        // ---- Init ----
        const initialOption = section.querySelector('[data-spotlight-collection-tab-ref].is-active') || section.querySelector('[data-spotlight-collection-tab-ref]');
        const initialTargetId = initialOption?.dataset.spotlightCollectionTabRef;
        if (initialTargetId) {
          activateCollection(initialTargetId);
        } else {
          applyFilters();
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => initDrawerSpotlight());
    document.addEventListener('shopify:section:load', (event) => initDrawerSpotlight(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stagmenfashion-story-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initChibiStories = (scope = document) => {
      scope.querySelectorAll('[data-stagmenfashion-story-collections]').forEach((section) => {
        if (section.dataset.ready === 'true') return;
        section.dataset.ready = 'true';

        const tabs = Array.from(section.querySelectorAll('[data-story-tab]'));
        const panels = Array.from(section.querySelectorAll('[data-story-panel]'));
        const seeAll = section.querySelector('[data-story-see-all]');
        const cartAddUrl = section.dataset.cartAddUrl || '/cart/add';

        if (!tabs.length || !panels.length) return;

        const activate = (targetId) => {
          tabs.forEach((tab) => {
            const isActive = tab.dataset.storyTarget === targetId;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const isActive = panel.id === targetId;
            panel.hidden = !isActive;
            panel.classList.toggle('is-active', isActive);

            if (isActive && seeAll && panel.dataset.storyUrl) {
              seeAll.href = panel.dataset.storyUrl;
            }
          });
        };

        tabs.forEach((tab) => tab.addEventListener('click', () => activate(tab.dataset.storyTarget)));

        section.querySelectorAll('[data-stagmenfashion-story-add]').forEach((button) => {
          button.addEventListener('click', async (event) => {
            event.preventDefault();

            const form = button.closest('form');
            const variantId = form?.querySelector('input[name="id"]')?.value;
            if (!variantId) return;

            button.disabled = true;

            try {
              const response = await fetch(`${cartAddUrl}.js`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
              });

              const cart = await response.json();
              if (!response.ok || cart?.status) throw new Error(cart?.description || cart?.message || 'Add to cart failed');

              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    data: {
                      source: 'stagmenfashion-story-collections',
                      itemCount: cart.item_count,
                    },
                  },
                })
              );

              document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
            } catch (error) {
              console.error(error);
            } finally {
              button.disabled = false;
            }
          });
        });

        const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
        if (activeTab?.dataset.storyTarget) {
          activate(activeTab.dataset.storyTarget);
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => initChibiStories());
    document.addEventListener('shopify:section:load', (event) => initChibiStories(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-drawer"]) return;
  try {
    
(function() {
  const drawer   = document.getElementById('wishlist-drawer');
  const closeBtn = document.getElementById('wishlist-drawer-close');
  const grid     = document.getElementById('wishlist-drawer-grid');
  const empty    = document.getElementById('wishlist-drawer-empty');
  const footer   = document.getElementById('wishlist-drawer-footer');
  const countEl  = document.getElementById('wishlist-drawer-count');
  const clearBtn = document.getElementById('wishlist-drawer-clear-btn');
  const toast    = document.getElementById('wishlist-drawer-toast');
  const continueBtn = document.getElementById('wishlist-continue-shop-btn');
  const confirmModal = document.getElementById('wl-clear-modal');
  const confirmClearBtn = document.getElementById('wl-clear-confirm-btn');

  if (!drawer) return;

  function openWlClearModal() {
    if (!confirmModal) return;
    confirmModal.removeAttribute('hidden');
    confirmModal.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      confirmModal.classList.add('is-active');
    });
  }

  function closeWlClearModal() {
    if (!confirmModal) return;
    confirmModal.classList.remove('is-active');
    confirmModal.setAttribute('aria-hidden', 'true');
    setTimeout(() => {
      confirmModal.setAttribute('hidden', '');
    }, 200);
  }

  function executeWlClear() {
    closeWlClearModal();
    if (typeof window.clearWishlist === 'function') {
      window.clearWishlist();
    } else {
      localStorage.setItem('wishlist', '[]');
      document.dispatchEvent(new CustomEvent('wishlist:update'));
    }
    showToast('Wishlist cleared');
  }

  let toastTimer = null;
  function showToast(msg, duration = 2200) {
    if (!toast) return;
    toast.textContent = msg;
    toast.style.display = 'block';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.style.display = 'none';
    }, duration);
  }

  function formatDisplayPrice(rawPrice) {
    if (!rawPrice) return '';
    const str = String(rawPrice).trim();
    // If already has currency symbols or words
    if (/[^\d.,\s]/.test(str)) {
      return str;
    }
    const val = parseFloat(str.replace(/,/g, ''));
    if (isNaN(val)) return str;
    
    const currency = drawer.dataset.currency || '$';
    return `${currency}${val.toFixed(2)}`;
  }

  let previousScrollY = 0;

  function openDrawer() {
    if (drawer.open) return;
    previousScrollY = window.scrollY || window.pageYOffset || 0;

    requestAnimationFrame(() => {
      document.body.style.width = '100%';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${previousScrollY}px`;

      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
      } else {
        drawer.setAttribute('open', '');
      }
      renderGrid();
      document.dispatchEvent(new CustomEvent('dialog:open'));
    });
  }

  function closeDrawer() {
    if (!drawer.open) return;
    drawer.classList.add('dialog-closing');
    setTimeout(() => {
      drawer.classList.remove('dialog-closing');
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.removeAttribute('open');
      }
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo({ top: previousScrollY, behavior: 'instant' });
      document.dispatchEvent(new CustomEvent('dialog:close'));
    }, 200);
  }

  // Close handlers
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (continueBtn) continueBtn.addEventListener('click', closeDrawer);
  drawer.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
  drawer.addEventListener('click', e => { if (e.target === drawer) closeDrawer(); });

  // Clear modal handlers
  if (clearBtn) clearBtn.addEventListener('click', openWlClearModal);
  if (confirmClearBtn) confirmClearBtn.addEventListener('click', executeWlClear);
  drawer.addEventListener('click', e => {
    if (e.target.closest('[data-wl-clear-cancel]')) {
      e.preventDefault();
      closeWlClearModal();
    }
  });

  // Add to Bag handler inside drawer
  grid.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-wl-add-cart]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    let variantId = btn.dataset.wlAddCart;
    const handle = btn.dataset.productHandle;
    const size = btn.dataset.productSize || '';
    const color = btn.dataset.productColor || '';

    btn.classList.add('is-loading');
    const originalContent = btn.innerHTML;
    btn.innerHTML = '<span class="wl-row-item__spinner"></span>';

    try {
      const getSectionId = () => {
        const comp = document.querySelector('cart-items-component[data-drawer]') || document.querySelector('cart-items-component');
        return comp?.dataset.sectionId || 'cart-drawer';
      };

      const attemptAdd = async (vId) => {
        if (!vId) return { success: false, err: { description: 'Missing variant ID' } };
        const sectionId = getSectionId();
        const bodyData = {
          id: Number(vId),
          quantity: 1,
          sections: sectionId,
          sections_url: window.location.pathname
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(bodyData)
        });
        if (response.ok) {
          const item = await response.json();
          return { success: true, item, sectionId };
        } else {
          const err = await response.json().catch(() => ({}));
          return { success: false, err, sectionId };
        }
      };

      let result = await attemptAdd(variantId);

      // If failed (e.g. variant ID was product ID, outdated, or missing), fetch product JSON and check availability
      if (!result.success && handle) {
        try {
          const prodRes = await fetch(`/products/${handle}.js`);
          if (prodRes.ok) {
            const product = await prodRes.json();
            if (product && product.variants && product.variants.length > 0) {
              let matchedVariant = null;
              const sLower = size && size !== 'Default' ? String(size).trim().toLowerCase() : '';
              const cLower = color ? String(color).trim().toLowerCase() : '';

              if (sLower || cLower) {
                matchedVariant = product.variants.find(v => {
                  const o1 = (v.option1 || '').trim().toLowerCase();
                  const o2 = (v.option2 || '').trim().toLowerCase();
                  const o3 = (v.option3 || '').trim().toLowerCase();
                  const opts = (v.options || []).map(o => String(o).trim().toLowerCase());
                  const matchSize = !sLower || o1 === sLower || o2 === sLower || o3 === sLower || opts.includes(sLower);
                  const matchColor = !cLower || o1 === cLower || o2 === cLower || o3 === cLower || opts.includes(cLower);
                  return matchSize && matchColor;
                });
              }
              if (!matchedVariant && sLower) {
                matchedVariant = product.variants.find(v => 
                  (v.option1 && v.option1.toLowerCase() === sLower) ||
                  (v.option2 && v.option2.toLowerCase() === sLower) ||
                  (v.option3 && v.option3.toLowerCase() === sLower) ||
                  (v.title && v.title.toLowerCase() === sLower)
                );
              }
              if (!matchedVariant) {
                matchedVariant = product.variants.find(v => v.available) || product.variants[0];
              }

              if (matchedVariant) {
                // Check if this variant is out of stock (0 stock)
                if (!matchedVariant.available) {
                  let list = JSON.parse(localStorage.getItem('wishlist') || '[]');
                  const itemIndex = list.findIndex(i => i.handle === handle);
                  if (itemIndex > -1) {
                    list[itemIndex].available = false;
                    localStorage.setItem('wishlist', JSON.stringify(list));
                    renderGrid();
                  }
                  const stockOutMsg = size && size !== 'Default' 
                    ? `Size ${size} is out of stock` 
                    : 'This item is out of stock';
                  showToast(stockOutMsg);
                  return;
                }

                if (matchedVariant.id) {
                  variantId = matchedVariant.id;
                  result = await attemptAdd(variantId);
                  if (result.success) {
                    // Update localStorage wishlist with resolved variantId
                    let list = JSON.parse(localStorage.getItem('wishlist') || '[]');
                    const itemIndex = list.findIndex(i => i.handle === handle);
                    if (itemIndex > -1) {
                      list[itemIndex].variantId = variantId;
                      list[itemIndex].available = true;
                      localStorage.setItem('wishlist', JSON.stringify(list));
                    }
                  }
                }
              }
            }
          }
        } catch (err) {
          console.error('Error resolving variant stock:', err);
        }
      }

      if (result.success) {
        showToast(`Added to Bag`);

        const cartDrawer = document.querySelector('cart-drawer-component');
        const sectionId = result.sectionId || getSectionId();

        // Dispatch cart updates
        const eventDetail = {
          resource: result.item,
          data: {
            ...result.item,
            sections: result.item.sections || {}
          },
          sourceId: 'wishlist-drawer'
        };

        document.dispatchEvent(new CustomEvent('cart:update', { detail: eventDetail }));
        window.dispatchEvent(new CustomEvent('cart:update', { detail: eventDetail }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        // Re-render cart drawer DOM immediately from section rendering
        if (result.item.sections && result.item.sections[sectionId]) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(result.item.sections[sectionId], 'text/html');
          const newInner = doc.querySelector('.pf-cart-drawer__inner') || doc.querySelector('.cart-drawer__inner');
          const currentInner = document.querySelector('.pf-cart-drawer__inner') || document.querySelector('.cart-drawer__inner');
          if (newInner && currentInner) {
            currentInner.innerHTML = newInner.innerHTML;
          }
        }

        // Close wishlist drawer and open cart drawer smoothly
        closeDrawer();
        setTimeout(() => {
          if (cartDrawer) {
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else if (typeof cartDrawer.showDialog === 'function') {
              cartDrawer.showDialog();
            }
            const dialog = cartDrawer.querySelector('dialog');
            if (dialog && !dialog.open) {
              dialog.showModal ? dialog.showModal() : dialog.setAttribute('open', '');
            }
          } else {
            const cartDrawerTrigger = document.querySelector('[data-testid="cart-drawer-trigger"], [data-open-cart-drawer], .stagmenfashion-header__cart-button, .pf-header__cart-button');
            if (cartDrawerTrigger) cartDrawerTrigger.click();
          }
        }, 220);
      } else {
        let msg = result.err?.description || result.err?.message || '';
        if (/out of stock|sold out|inventory|unavailable/i.test(msg)) {
          msg = size && size !== 'Default' ? `Size ${size} is out of stock` : 'This item is out of stock';
          let list = JSON.parse(localStorage.getItem('wishlist') || '[]');
          const itemIndex = list.findIndex(i => i.handle === handle);
          if (itemIndex > -1) {
            list[itemIndex].available = false;
            localStorage.setItem('wishlist', JSON.stringify(list));
            renderGrid();
          }
        }
        showToast(msg || 'Could not add item');
      }
    } catch (error) {
      showToast('Error adding to bag.');
    } finally {
      btn.classList.remove('is-loading');
      btn.innerHTML = originalContent;
    }
  });

  // Remove handler with smooth animation
  grid.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('[data-wishlist-remove]');
    if (!removeBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = removeBtn.dataset.wishlistRemove;
    const itemEl = removeBtn.closest('.wl-row-item');

    if (itemEl) {
      itemEl.classList.add('is-removing');
      setTimeout(() => {
        if (typeof window.removeFromWishlist === 'function') {
          window.removeFromWishlist(handle);
        } else {
          let list = JSON.parse(localStorage.getItem('wishlist') || '[]');
          list = list.filter(i => i.handle !== handle);
          localStorage.setItem('wishlist', JSON.stringify(list));
          document.dispatchEvent(new CustomEvent('wishlist:update'));
        }
      }, 200);
    }
  });

  async function validateWishlistStock() {
    const list = JSON.parse(localStorage.getItem('wishlist') || '[]');
    if (!list || list.length === 0) return;

    let modified = false;
    await Promise.all(list.map(async (item, idx) => {
      if (!item.handle) return;
      try {
        const res = await fetch(`/products/${item.handle}.js`);
        if (!res.ok) return;
        const prod = await res.json();
        if (!prod) return;

        let isAvail = prod.available;
        if (item.size && item.size !== 'Default' && prod.variants) {
          const sLower = String(item.size).trim().toLowerCase();
          const v = prod.variants.find(v => 
            (v.option1 && v.option1.toLowerCase() === sLower) ||
            (v.option2 && v.option2.toLowerCase() === sLower) ||
            (v.option3 && v.option3.toLowerCase() === sLower) ||
            (v.title && v.title.toLowerCase() === sLower)
          );
          if (v) isAvail = v.available;
        }

        if (item.available !== isAvail) {
          list[idx].available = isAvail;
          modified = true;
        }
      } catch (e) {}
    }));

    if (modified) {
      localStorage.setItem('wishlist', JSON.stringify(list));
      renderGrid();
    }
  }

  function renderGrid() {
    const list = JSON.parse(localStorage.getItem('wishlist') || '[]');
    const count = list.length;

    if (countEl) countEl.textContent = `${count}`;

    if (count === 0) {
      grid.innerHTML = '';
      grid.style.display   = 'none';
      empty.style.display  = 'flex';
      footer.style.display = 'none';
      return;
    }

    grid.style.display   = 'flex';
    empty.style.display  = 'none';
    footer.style.display = 'flex';

    grid.innerHTML = list.map(item => {
      const t = (item.title || '').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      const img = item.image || '';
      const params = new URLSearchParams();
      if (item.variantId) {
        params.set('variant', item.variantId);
      }
      if (item.color) {
        params.set('color', item.color);
      }
      if (item.size && item.size !== 'Default') {
        params.set('size', item.size);
      }
      const qs = params.toString();
      const productUrl = '/products/' + item.handle + (qs ? '?' + qs : '');
      const variantId = item.variantId || item.id || '';
      const formattedPrice = formatDisplayPrice(item.price);
      const isUnavailable = item.available === false || item.available === 'false';

      return `
        <article class="wl-row-item" data-handle="${item.handle}">
          <!-- 1. Left Image Card -->
          <div class="wl-row-item__media-wrap">
            <a class="wl-row-item__media-link" href="${productUrl}">
              ${img ? `<img class="wl-row-item__img" src="${img}" alt="${t}" loading="lazy">` : `<div class="wl-row-item__placeholder"></div>`}
            </a>
          </div>

          <!-- 2. Middle Content: Title and Price Under -->
          <div class="wl-row-item__info">
            <a class="wl-row-item__title" href="${productUrl}" title="${t}">${t}</a>
            ${(() => {
              const metaParts = [];
              if (item.color) metaParts.push(`Color: ${item.color}`);
              if (item.size && item.size !== 'Default') metaParts.push(`Size: ${item.size}`);
              return metaParts.length > 0 ? `<div class="wl-row-item__meta">${metaParts.join(' &bull; ')}</div>` : '';
            })()}
            <div class="wl-row-item__price">${formattedPrice}</div>
          </div>

          <!-- 3. Right End Actions: Cart Icon & Remove Icon -->
          <div class="wl-row-item__actions">
            ${isUnavailable ? `
              <span class="wl-row-item__soldout-btn" title="Out of Stock">Out of Stock</span>
            ` : (variantId || item.handle) ? `
              <button
                type="button"
                class="wl-row-item__cart-btn"
                data-wl-add-cart="${variantId}"
                data-product-handle="${item.handle}"
                data-product-size="${item.size || ''}"
                data-product-color="${item.color || ''}"
                data-product-title="${t}"
                title="Add to Bag"
                aria-label="Add to Bag"
              >
                <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <path d="M16 10a4 4 0 0 1-8 0"></path>
                </svg>
              </button>
            ` : `
              <a
                href="${productUrl}"
                class="wl-row-item__view-btn"
                title="View Product"
                aria-label="View Product"
              >
                <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                  <polyline points="15 3 21 3 21 9"></polyline>
                  <line x1="10" y1="14" x2="21" y2="3"></line>
                </svg>
              </a>
            `}

            <button
              class="wl-row-item__remove-btn"
              type="button"
              aria-label="Remove item"
              title="Remove from wishlist"
              data-wishlist-remove="${item.handle}"
            >
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </button>
          </div>
        </article>`;
    }).join('');
  }

  // Re-render when wishlist changes
  document.addEventListener('wishlist:update', renderGrid);

  // Listen for the open trigger (header button dispatches this)
  document.addEventListener('wishlist-drawer:open', () => {
    openDrawer();
    validateWishlistStock();
  });
  document.addEventListener('wishlist-drawer:close', closeDrawer);

  // Expose globally so the header button or scripts can call it
  window.openWishlistDrawer = () => {
    openDrawer();
    validateWishlistStock();
  };
  window.closeWishlistDrawer = closeDrawer;
})();

  } catch(e) { console.error(e); }
})();
})();
